var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayButtonBoy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 46.6 69.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #011;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #00d0d0;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #001010;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #003636;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: aqua;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #181818;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #292828;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: #014975;\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: #c1c1c1;\r\n      }\r\n\r\n      .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18 {\r\n        mix-blend-mode: multiply;\r\n      }\r\n\r\n      .cls-9, .cls-11, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18 {\r\n        opacity: .5;\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: #111;\r\n      }\r\n\r\n      .cls-20 {\r\n        fill: #888585;\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: #00ecec;\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: #5d5b5b;\r\n      }\r\n\r\n      .cls-23 {\r\n        fill: #005050;\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: #9e9d9d;\r\n      }\r\n\r\n      .cls-25 {\r\n        fill: #141313;\r\n      }\r\n\r\n      .cls-26 {\r\n        fill: #009797;\r\n      }\r\n\r\n      .cls-27 {\r\n        fill: #0f2938;\r\n      }\r\n\r\n      .cls-28 {\r\n        fill: #002929;\r\n      }\r\n\r\n      .cls-29 {\r\n        fill: #001212;\r\n      }\r\n\r\n      .cls-30 {\r\n        fill: #474646;\r\n      }\r\n\r\n      .cls-31 {\r\n        fill: #2d2c2c;\r\n      }\r\n\r\n      .cls-32 {\r\n        fill: #7d7b7b;\r\n      }\r\n\r\n      .cls-33 {\r\n        fill: #5c5a5a;\r\n      }\r\n\r\n      .cls-34 {\r\n        fill: #2e2d2d;\r\n      }\r\n\r\n      .cls-35 {\r\n        fill: #000909;\r\n      }\r\n\r\n      .cls-36 {\r\n        fill: #00d9d9;\r\n      }\r\n\r\n      .cls-37 {\r\n        fill: #252525;\r\n      }\r\n\r\n      .cls-38 {\r\n        fill: #010101;\r\n      }\r\n\r\n      .cls-39 {\r\n        fill: #201f1f;\r\n      }\r\n\r\n      .cls-40 {\r\n        fill: #006161;\r\n      }\r\n\r\n      .cls-41 {\r\n        fill: #00f5f5;\r\n      }\r\n\r\n      .cls-42 {\r\n        fill: #00e0e0;\r\n      }\r\n\r\n      .cls-43 {\r\n        fill: #595757;\r\n      }\r\n\r\n      .cls-44 {\r\n        fill: #004c4c;\r\n      }\r\n\r\n      .cls-45 {\r\n        fill: #00fefe;\r\n      }\r\n\r\n      .cls-46 {\r\n        fill: #000b0b;\r\n      }\r\n\r\n      .cls-47 {\r\n        fill: #006868;\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: #ff9f00;\r\n      }\r\n\r\n      .cls-48 {\r\n        fill: #575555;\r\n      }\r\n\r\n      .cls-49 {\r\n        fill: #033;\r\n      }\r\n\r\n      .cls-50 {\r\n        fill: #323131;\r\n      }\r\n\r\n      .cls-51 {\r\n        fill: #00fcfc;\r\n      }\r\n\r\n      .cls-52 {\r\n        fill: #827f7f;\r\n      }\r\n\r\n      .cls-53 {\r\n        fill: #003434;\r\n      }\r\n\r\n      .cls-11, .cls-54, .cls-55 {\r\n        fill: #424242;\r\n      }\r\n\r\n      .cls-56 {\r\n        fill: #898686;\r\n      }\r\n\r\n      .cls-57 {\r\n        fill: #000f0f;\r\n      }\r\n\r\n      .cls-54, .cls-58, .cls-59, .cls-60 {\r\n        mix-blend-mode: screen;\r\n      }\r\n\r\n      .cls-61 {\r\n        fill: #3c3a3a;\r\n      }\r\n\r\n      .cls-62 {\r\n        fill: #007171;\r\n      }\r\n\r\n      .cls-12, .cls-63 {\r\n        fill: #ffaeae;\r\n      }\r\n\r\n      .cls-12, .cls-58, .cls-60 {\r\n        opacity: .6;\r\n      }\r\n\r\n      .cls-64 {\r\n        fill: #003e3e;\r\n      }\r\n\r\n      .cls-65 {\r\n        fill: #00a5a5;\r\n      }\r\n\r\n      .cls-66 {\r\n        fill: #00a7a7;\r\n      }\r\n\r\n      .cls-67 {\r\n        fill: #002a2a;\r\n      }\r\n\r\n      .cls-68 {\r\n        fill: #003a3a;\r\n      }\r\n\r\n      .cls-69 {\r\n        fill: #696666;\r\n      }\r\n\r\n      .cls-70 {\r\n        fill: #000a0a;\r\n      }\r\n\r\n      .cls-71 {\r\n        fill: #00d8d8;\r\n      }\r\n\r\n      .cls-72 {\r\n        fill: #001f1f;\r\n      }\r\n\r\n      .cls-73 {\r\n        fill: #121212;\r\n      }\r\n\r\n      .cls-74 {\r\n        fill: #080808;\r\n      }\r\n\r\n      .cls-75 {\r\n        fill: #4f4d4d;\r\n      }\r\n\r\n      .cls-76 {\r\n        fill: #00c4c4;\r\n      }\r\n\r\n      .cls-77 {\r\n        fill: #272727;\r\n      }\r\n\r\n      .cls-78 {\r\n        fill: #00f1f1;\r\n      }\r\n\r\n      .cls-79 {\r\n        fill: #737070;\r\n      }\r\n\r\n      .cls-80 {\r\n        fill: #000707;\r\n      }\r\n\r\n      .cls-81 {\r\n        fill: #002c2c;\r\n      }\r\n\r\n      .cls-82 {\r\n        fill: #0c0c0c;\r\n      }\r\n\r\n      .cls-83 {\r\n        fill: #777575;\r\n      }\r\n\r\n      .cls-84 {\r\n        fill: #00f4f4;\r\n      }\r\n\r\n      .cls-85 {\r\n        fill: #0ee;\r\n      }\r\n\r\n      .cls-86 {\r\n        fill: #00f8f8;\r\n      }\r\n\r\n      .cls-87 {\r\n        fill: #009c9c;\r\n      }\r\n\r\n      .cls-88 {\r\n        fill: #005c5c;\r\n      }\r\n\r\n      .cls-89 {\r\n        fill: #00b0b0;\r\n      }\r\n\r\n      .cls-90 {\r\n        fill: #151414;\r\n      }\r\n\r\n      .cls-91 {\r\n        fill: #006060;\r\n      }\r\n\r\n      .cls-92 {\r\n        fill: #020202;\r\n      }\r\n\r\n      .cls-93 {\r\n        fill: #0dd;\r\n      }\r\n\r\n      .cls-94, .cls-15, .cls-60 {\r\n        fill: #ad4f1f;\r\n      }\r\n\r\n      .cls-95 {\r\n        fill: #00b3b3;\r\n      }\r\n\r\n      .cls-96 {\r\n        fill: #403f3f;\r\n      }\r\n\r\n      .cls-97 {\r\n        fill: #242323;\r\n      }\r\n\r\n      .cls-98 {\r\n        fill: #005b5b;\r\n      }\r\n\r\n      .cls-99 {\r\n        fill: #222121;\r\n      }\r\n\r\n      .cls-100 {\r\n        fill: #7c7979;\r\n      }\r\n\r\n      .cls-101 {\r\n        fill: #00a9a9;\r\n      }\r\n\r\n      .cls-102 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-103 {\r\n        fill: #006363;\r\n      }\r\n\r\n      .cls-104 {\r\n        fill: #007878;\r\n      }\r\n\r\n      .cls-105 {\r\n        fill: #002525;\r\n      }\r\n\r\n      .cls-106 {\r\n        fill: #454444;\r\n      }\r\n\r\n      .cls-107 {\r\n        fill: #00e8e8;\r\n      }\r\n\r\n      .cls-108 {\r\n        fill: #00efef;\r\n      }\r\n\r\n      .cls-109 {\r\n        fill: #3b3939;\r\n      }\r\n\r\n      .cls-110 {\r\n        fill: #005454;\r\n      }\r\n\r\n      .cls-111 {\r\n        fill: #066;\r\n      }\r\n\r\n      .cls-112 {\r\n        fill: #004949;\r\n      }\r\n\r\n      .cls-113 {\r\n        fill: #005353;\r\n      }\r\n\r\n      .cls-114 {\r\n        fill: #003f3f;\r\n      }\r\n\r\n      .cls-115 {\r\n        fill: #002626;\r\n      }\r\n\r\n      .cls-116 {\r\n        fill: #003131;\r\n      }\r\n\r\n      .cls-117 {\r\n        fill: #448ebc;\r\n      }\r\n\r\n      .cls-118 {\r\n        fill: #008484;\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: #c4c4c4;\r\n        opacity: .7;\r\n      }\r\n\r\n      .cls-119 {\r\n        fill: #00c8c8;\r\n      }\r\n\r\n      .cls-120 {\r\n        fill: #ff4d4d;\r\n      }\r\n\r\n      .cls-121 {\r\n        fill: #817e7e;\r\n      }\r\n\r\n      .cls-122 {\r\n        fill: #090909;\r\n      }\r\n\r\n      .cls-123 {\r\n        fill: #002727;\r\n      }\r\n\r\n      .cls-124 {\r\n        fill: #373535;\r\n      }\r\n\r\n      .cls-125 {\r\n        fill: #001c1c;\r\n      }\r\n\r\n      .cls-126 {\r\n        fill: #383636;\r\n      }\r\n\r\n      .cls-127 {\r\n        fill: #005656;\r\n      }\r\n\r\n      .cls-128 {\r\n        fill: #050505;\r\n      }\r\n\r\n      .cls-129 {\r\n        fill: #00e5e5;\r\n      }\r\n\r\n      .cls-130 {\r\n        fill: #262626;\r\n      }\r\n\r\n      .cls-131 {\r\n        fill: #00f0f0;\r\n      }\r\n\r\n      .cls-132 {\r\n        fill: #000e0e;\r\n      }\r\n\r\n      .cls-133 {\r\n        fill: #4a4848;\r\n      }\r\n\r\n      .cls-134 {\r\n        fill: #088;\r\n      }\r\n\r\n      .cls-135 {\r\n        fill: #060606;\r\n      }\r\n\r\n      .cls-136 {\r\n        fill: #2f2e2e;\r\n      }\r\n\r\n      .cls-137 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-138 {\r\n        fill: #00acac;\r\n      }\r\n\r\n      .cls-139 {\r\n        fill: #001d1d;\r\n      }\r\n\r\n      .cls-140 {\r\n        fill: #000101;\r\n      }\r\n\r\n      .cls-141 {\r\n        fill: #535151;\r\n      }\r\n\r\n      .cls-142 {\r\n        fill: #747171;\r\n      }\r\n\r\n      .cls-143 {\r\n        fill: #3a3a39;\r\n      }\r\n\r\n      .cls-144 {\r\n        fill: #676565;\r\n      }\r\n\r\n      .cls-145, .cls-14 {\r\n        fill: #0070c0;\r\n      }\r\n\r\n      .cls-146 {\r\n        fill: #807d7d;\r\n      }\r\n\r\n      .cls-147 {\r\n        fill: #6b0b0b;\r\n      }\r\n\r\n      .cls-148 {\r\n        fill: #726f6f;\r\n      }\r\n\r\n      .cls-149 {\r\n        fill: #006565;\r\n      }\r\n\r\n      .cls-150 {\r\n        fill: #302f2f;\r\n      }\r\n\r\n      .cls-151 {\r\n        fill: #585656;\r\n      }\r\n\r\n      .cls-152 {\r\n        fill: #00e9e9;\r\n      }\r\n\r\n      .cls-153 {\r\n        fill: #276e91;\r\n      }\r\n\r\n      .cls-154 {\r\n        fill: #008686;\r\n      }\r\n\r\n      .cls-155 {\r\n        fill: #666464;\r\n      }\r\n\r\n      .cls-156 {\r\n        fill: #131212;\r\n      }\r\n\r\n      .cls-157 {\r\n        fill: #00dbdb;\r\n      }\r\n\r\n      .cls-158 {\r\n        fill: #00aeae;\r\n      }\r\n\r\n      .cls-159 {\r\n        fill: #00caca;\r\n      }\r\n\r\n      .cls-160 {\r\n        fill: #001818;\r\n      }\r\n\r\n      .cls-161 {\r\n        fill: #008282;\r\n      }\r\n\r\n      .cls-162 {\r\n        fill: #002121;\r\n      }\r\n\r\n      .cls-163 {\r\n        fill: #00d7d7;\r\n      }\r\n\r\n      .cls-164 {\r\n        fill: #171717;\r\n      }\r\n\r\n      .cls-165 {\r\n        fill: #5e5c5c;\r\n      }\r\n\r\n      .cls-166 {\r\n        fill: #464545;\r\n      }\r\n\r\n      .cls-167 {\r\n        fill: #00d1d1;\r\n      }\r\n\r\n      .cls-168 {\r\n        fill: #00fdfd;\r\n      }\r\n\r\n      .cls-169 {\r\n        fill: #00a2a2;\r\n      }\r\n\r\n      .cls-170 {\r\n        clip-path: url(#clippath-1);\r\n      }\r\n\r\n      .cls-171 {\r\n        fill: #434242;\r\n      }\r\n\r\n      .cls-172 {\r\n        fill: #002424;\r\n      }\r\n\r\n      .cls-173 {\r\n        fill: #5b5959;\r\n      }\r\n\r\n      .cls-174 {\r\n        fill: #004747;\r\n      }\r\n\r\n      .cls-175 {\r\n        fill: #00d4d4;\r\n      }\r\n\r\n      .cls-176 {\r\n        fill: #878484;\r\n      }\r\n\r\n      .cls-177 {\r\n        fill: #2b2a2a;\r\n      }\r\n\r\n      .cls-178 {\r\n        fill: #009595;\r\n      }\r\n\r\n      .cls-179 {\r\n        fill: #040303;\r\n      }\r\n\r\n      .cls-180 {\r\n        fill: #626060;\r\n      }\r\n\r\n      .cls-181 {\r\n        fill: #484747;\r\n      }\r\n\r\n      .cls-182 {\r\n        fill: #757373;\r\n      }\r\n\r\n      .cls-183 {\r\n        fill: #000c0c;\r\n      }\r\n\r\n      .cls-184 {\r\n        fill: #5a5858;\r\n      }\r\n\r\n      .cls-185 {\r\n        fill: #004e4e;\r\n      }\r\n\r\n      .cls-186 {\r\n        fill: #60260d;\r\n      }\r\n\r\n      .cls-187 {\r\n        fill: #00cfcf;\r\n      }\r\n\r\n      .cls-188 {\r\n        fill: #003232;\r\n      }\r\n\r\n      .cls-189 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-190 {\r\n        fill: #bfbfbf;\r\n      }\r\n\r\n      .cls-191 {\r\n        fill: #212020;\r\n      }\r\n\r\n      .cls-192 {\r\n        fill: #282828;\r\n      }\r\n\r\n      .cls-193 {\r\n        fill: #3e3c3c;\r\n      }\r\n\r\n      .cls-194 {\r\n        fill: #0e0d0d;\r\n      }\r\n\r\n      .cls-195 {\r\n        fill: #00fafa;\r\n      }\r\n\r\n      .cls-196 {\r\n        fill: #2c2b2b;\r\n      }\r\n\r\n      .cls-197 {\r\n        fill: #636161;\r\n      }\r\n\r\n      .cls-198 {\r\n        fill: #004141;\r\n      }\r\n\r\n      .cls-199 {\r\n        fill: #545353;\r\n      }\r\n\r\n      .cls-200 {\r\n        fill: #003030;\r\n      }\r\n\r\n      .cls-201 {\r\n        fill: #1c1b1b;\r\n      }\r\n\r\n      .cls-202 {\r\n        fill: #7a7777;\r\n      }\r\n\r\n      .cls-203 {\r\n        fill: #00baba;\r\n      }\r\n\r\n      .cls-204 {\r\n        fill: #514f4f;\r\n      }\r\n\r\n      .cls-205 {\r\n        fill: #001717;\r\n      }\r\n\r\n      .cls-206 {\r\n        fill: #1f1e1e;\r\n      }\r\n\r\n      .cls-207 {\r\n        fill: #008a8a;\r\n      }\r\n\r\n      .cls-208 {\r\n        fill: #7b7878;\r\n      }\r\n\r\n      .cls-209 {\r\n        fill: #4c4a4a;\r\n      }\r\n\r\n      .cls-210 {\r\n        fill: #007575;\r\n      }\r\n\r\n      .cls-211 {\r\n        clip-path: url(#clippath-3);\r\n      }\r\n\r\n      .cls-212 {\r\n        fill: #00c2c2;\r\n      }\r\n\r\n      .cls-213 {\r\n        fill: #00c7c7;\r\n      }\r\n\r\n      .cls-214 {\r\n        fill: #005959;\r\n      }\r\n\r\n      .cls-215 {\r\n        fill: #646262;\r\n      }\r\n\r\n      .cls-216 {\r\n        fill: #000202;\r\n      }\r\n\r\n      .cls-217 {\r\n        fill: #00e7e7;\r\n      }\r\n\r\n      .cls-218 {\r\n        fill: #00cbcb;\r\n      }\r\n\r\n      .cls-219 {\r\n        fill: #1d1c1c;\r\n      }\r\n\r\n      .cls-220 {\r\n        fill: #858383;\r\n      }\r\n\r\n      .cls-221 {\r\n        fill: #838080;\r\n      }\r\n\r\n      .cls-222 {\r\n        fill: #6b6868;\r\n      }\r\n\r\n      .cls-223 {\r\n        fill: #001414;\r\n      }\r\n\r\n      .cls-224 {\r\n        fill: #3f3d3d;\r\n      }\r\n\r\n      .cls-225 {\r\n        fill: #030303;\r\n      }\r\n\r\n      .cls-226 {\r\n        fill: #00f2f2;\r\n      }\r\n\r\n      .cls-227 {\r\n        fill: #00e6e6;\r\n      }\r\n\r\n      .cls-228 {\r\n        fill: #0d0d0d;\r\n      }\r\n\r\n      .cls-229 {\r\n        fill: #00cece;\r\n      }\r\n\r\n      .cls-230 {\r\n        fill: #615f5f;\r\n      }\r\n\r\n      .cls-231 {\r\n        fill: #0e1b30;\r\n      }\r\n\r\n      .cls-232 {\r\n        fill: #002b2b;\r\n      }\r\n\r\n      .cls-233 {\r\n        fill: #3a3838;\r\n      }\r\n\r\n      .cls-234 {\r\n        fill: #002020;\r\n      }\r\n\r\n      .cls-235 {\r\n        fill: #002d2d;\r\n      }\r\n\r\n      .cls-236 {\r\n        fill: #002e2e;\r\n      }\r\n\r\n      .cls-237 {\r\n        fill: #009191;\r\n      }\r\n\r\n      .cls-238 {\r\n        fill: #007e7e;\r\n      }\r\n\r\n      .cls-239 {\r\n        fill: #444343;\r\n      }\r\n\r\n      .cls-240 {\r\n        fill: #0f0f0f;\r\n      }\r\n\r\n      .cls-241 {\r\n        fill: #00d3d3;\r\n      }\r\n\r\n      .cls-242 {\r\n        fill: #0e0e0e;\r\n      }\r\n\r\n      .cls-243 {\r\n        fill: #003939;\r\n      }\r\n\r\n      .cls-244 {\r\n        fill: #00e2e2;\r\n      }\r\n\r\n      .cls-245 {\r\n        fill: #191919;\r\n      }\r\n\r\n      .cls-246 {\r\n        fill: #656363;\r\n      }\r\n\r\n      .cls-247 {\r\n        fill: #0b0b0b;\r\n      }\r\n\r\n      .cls-248 {\r\n        fill: #4b4949;\r\n      }\r\n\r\n      .cls-249 {\r\n        fill: #003737;\r\n      }\r\n\r\n      .cls-250 {\r\n        fill: #00b8b8;\r\n      }\r\n\r\n      .cls-251 {\r\n        fill: #002828;\r\n      }\r\n\r\n      .cls-252 {\r\n        fill: #007373;\r\n      }\r\n\r\n      .cls-253 {\r\n        fill: #001313;\r\n      }\r\n\r\n      .cls-254 {\r\n        fill: #00fbfb;\r\n      }\r\n\r\n      .cls-255 {\r\n        fill: #008c8c;\r\n      }\r\n\r\n      .cls-256 {\r\n        fill: #504e4e;\r\n      }\r\n\r\n      .cls-257 {\r\n        fill: #00a0a0;\r\n      }\r\n\r\n      .cls-258 {\r\n        fill: #1b1a1a;\r\n      }\r\n\r\n      .cls-259 {\r\n        fill: #2a2929;\r\n      }\r\n\r\n      .cls-260 {\r\n        fill: #007a7a;\r\n      }\r\n\r\n      .cls-261 {\r\n        fill: #00eded;\r\n      }\r\n\r\n      .cls-262 {\r\n        fill: #006a6a;\r\n      }\r\n\r\n      .cls-263 {\r\n        fill: #00f3f3;\r\n      }\r\n\r\n      .cls-264 {\r\n        fill: #3d3b3b;\r\n      }\r\n\r\n      .cls-265 {\r\n        fill: #1d5172;\r\n      }\r\n\r\n      .cls-266 {\r\n        fill: #001e1e;\r\n      }\r\n\r\n      .cls-267 {\r\n        fill: #000808;\r\n      }\r\n\r\n      .cls-268 {\r\n        fill: #009393;\r\n      }\r\n\r\n      .cls-269 {\r\n        fill: #00b5b5;\r\n      }\r\n\r\n      .cls-270 {\r\n        fill: #001515;\r\n      }\r\n\r\n      .cls-271 {\r\n        fill: #565454;\r\n      }\r\n\r\n      .cls-272 {\r\n        fill: #004d4d;\r\n      }\r\n\r\n      .cls-273 {\r\n        fill: teal;\r\n      }\r\n\r\n      .cls-274 {\r\n        fill: #a5a5a5;\r\n      }\r\n\r\n      .cls-275 {\r\n        fill: #001a1a;\r\n      }\r\n\r\n      .cls-276 {\r\n        fill: #6f6d6d;\r\n      }\r\n\r\n      .cls-277 {\r\n        fill: #6e6c6c;\r\n      }\r\n\r\n      .cls-278 {\r\n        fill: #006f6f;\r\n      }\r\n\r\n      .cls-279 {\r\n        fill: #424141;\r\n      }\r\n\r\n      .cls-280 {\r\n        fill: #4d4b4b;\r\n      }\r\n\r\n      .cls-281 {\r\n        fill: #00f9f9;\r\n      }\r\n\r\n      .cls-282 {\r\n        fill: #099;\r\n      }\r\n\r\n      .cls-283 {\r\n        fill: #003c3c;\r\n      }\r\n\r\n      .cls-284 {\r\n        fill: #7e7c7c;\r\n      }\r\n\r\n      .cls-285 {\r\n        fill: #6c6a6a;\r\n      }\r\n\r\n      .cls-286 {\r\n        fill: #00f7f7;\r\n      }\r\n\r\n      .cls-287 {\r\n        fill: #000505;\r\n      }\r\n\r\n      .cls-288 {\r\n        fill: #001616;\r\n      }\r\n\r\n      .cls-289 {\r\n        fill: #004545;\r\n      }\r\n\r\n      .cls-290 {\r\n        fill: #007c7c;\r\n      }\r\n\r\n      .cls-291 {\r\n        fill: #00f6f6;\r\n      }\r\n\r\n      .cls-292 {\r\n        fill: #006c6c;\r\n      }\r\n\r\n      .cls-293 {\r\n        fill: #008f8f;\r\n      }\r\n\r\n      .cls-294 {\r\n        fill: #6a6767;\r\n      }\r\n\r\n      .cls-295 {\r\n        clip-path: url(#clippath-2);\r\n      }\r\n\r\n      .cls-296 {\r\n        fill: #343333;\r\n      }\r\n\r\n      .cls-297 {\r\n        fill: #7f7f7f;\r\n      }\r\n\r\n      .cls-298 {\r\n        fill: #0a0909;\r\n      }\r\n\r\n      .cls-299 {\r\n        fill: #333232;\r\n      }\r\n\r\n      .cls-300 {\r\n        fill: #002f2f;\r\n      }\r\n\r\n      .cls-301 {\r\n        fill: #0a0a0a;\r\n      }\r\n\r\n      .cls-302 {\r\n        fill: #6d6b6b;\r\n      }\r\n\r\n      .cls-303 {\r\n        fill: #005e5e;\r\n      }\r\n\r\n      .cls-304 {\r\n        fill: #151515;\r\n      }\r\n\r\n      .cls-305 {\r\n        fill: #022;\r\n      }\r\n\r\n      .cls-306 {\r\n        fill: #00bdbd;\r\n      }\r\n\r\n      .cls-307 {\r\n        fill: #000303;\r\n      }\r\n\r\n      .cls-308 {\r\n        fill: #040404;\r\n      }\r\n\r\n      .cls-309 {\r\n        fill: #1e1d1d;\r\n      }\r\n\r\n      .cls-310 {\r\n        fill: #00dede;\r\n      }\r\n\r\n      .cls-311 {\r\n        fill: #004646;\r\n      }\r\n\r\n      .cls-312 {\r\n        fill: #313030;\r\n      }\r\n\r\n      .cls-313 {\r\n        fill: #004a4a;\r\n      }\r\n\r\n      .cls-314 {\r\n        fill: #000606;\r\n      }\r\n\r\n      .cls-315 {\r\n        fill: #070707;\r\n      }\r\n\r\n      .cls-316 {\r\n        fill: #077;\r\n      }\r\n\r\n      .cls-317 {\r\n        fill: #00eaea;\r\n      }\r\n\r\n      .cls-318 {\r\n        fill: #00d5d5;\r\n      }\r\n\r\n      .cls-319 {\r\n        fill: #1a1919;\r\n      }\r\n\r\n      .cls-320 {\r\n        fill: #242424;\r\n      }\r\n\r\n      .cls-321 {\r\n        fill: #00dfdf;\r\n      }\r\n\r\n      .cls-322 {\r\n        fill: #004343;\r\n      }\r\n\r\n      .cls-323 {\r\n        fill: #605d5d;\r\n      }\r\n\r\n      .cls-324 {\r\n        fill: #353434;\r\n      }\r\n\r\n      .cls-325, .cls-17 {\r\n        fill: #233559;\r\n      }\r\n\r\n      .cls-16, .cls-326 {\r\n        fill: #ff0;\r\n      }\r\n\r\n      .cls-327 {\r\n        fill: #009e9e;\r\n      }\r\n\r\n      .cls-328 {\r\n        fill: #00bfbf;\r\n      }\r\n\r\n      .cls-329 {\r\n        fill: #006d6d;\r\n      }\r\n\r\n      .cls-330 {\r\n        fill: #001b1b;\r\n      }\r\n\r\n      .cls-331 {\r\n        fill: #003d3d;\r\n      }\r\n\r\n      .cls-332 {\r\n        fill: #716e6e;\r\n      }\r\n\r\n      .cls-333 {\r\n        fill: #4e4c4c;\r\n      }\r\n\r\n      .cls-334 {\r\n        clip-path: url(#clippath);\r\n      }\r\n\r\n      .cls-335 {\r\n        fill: #003838;\r\n      }\r\n\r\n      .cls-336 {\r\n        fill: #101010;\r\n      }\r\n\r\n      .cls-337 {\r\n        fill: #005151;\r\n      }\r\n\r\n      .cls-338 {\r\n        fill: #000404;\r\n      }\r\n\r\n      .cls-339 {\r\n        fill: #767474;\r\n      }\r\n\r\n      .cls-340 {\r\n        fill: #848181;\r\n      }\r\n\r\n      .cls-341 {\r\n        fill: #00ebeb;\r\n      }\r\n\r\n      .cls-342 {\r\n        fill: #00e4e4;\r\n      }\r\n\r\n      .cls-343 {\r\n        fill: #00dada;\r\n      }\r\n\r\n      .cls-344 {\r\n        fill: #005858;\r\n      }\r\n\r\n      .cls-345 {\r\n        fill: #002323;\r\n      }\r\n\r\n      .cls-346 {\r\n        fill: #001919;\r\n      }\r\n\r\n      .cls-347 {\r\n        fill: #004242;\r\n      }\r\n\r\n      .cls-348 {\r\n        fill: #797676;\r\n      }\r\n\r\n      .cls-349 {\r\n        fill: #161616;\r\n      }\r\n\r\n      .cls-350 {\r\n        fill: #232222;\r\n      }\r\n\r\n      .cls-351 {\r\n        fill: #00e1e1;\r\n      }\r\n\r\n      .cls-352 {\r\n        fill: #414040;\r\n      }\r\n\r\n      .cls-353 {\r\n        fill: #000d0d;\r\n      }\r\n\r\n      .cls-354 {\r\n        fill: #393737;\r\n      }\r\n\r\n      .cls-355 {\r\n        fill: #0cc;\r\n      }\r\n\r\n      .cls-356 {\r\n        fill: #525050;\r\n      }\r\n\r\n      .cls-357 {\r\n        fill: #ece9ed;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M31.8,21.4c0,.8-.4,1.4-1,1.4s-1-.6-1.1-1.4c0-.8.4-1.4,1-1.4.6,0,1,.6,1.1,1.4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M30,22c0,.2.2.3.4.3.2,0,.4-.2.4-.3,0-.2-.2-.3-.4-.3-.2,0-.4.2-.4.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M18.5,21.7c0,.8.5,1.4,1.1,1.4.6,0,1-.7,1-1.4,0-.8-.5-1.4-1.1-1.4-.6,0-1,.7-1,1.4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M20.3,22.3c0,.2-.2.3-.4.3-.2,0-.4-.1-.4-.3,0-.2.2-.3.4-.3.2,0,.4.1.4.3Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M11.3,23.1s-.6,1.7,1,2.1c-.2,1.1.2,1.9,1.4,1.7.8,1.2,2.2.5,2.2.5l-1.2-4.4h-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M11.3,23.1s-.6,1.7,1,2.1c-.2,1.1.2,1.9,1.4,1.7.8,1.2,2.2.5,2.2.5l-1.2-4.4h-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6,23.1l1.2,4.3c-.3.1-1.3.5-2-.5h0s0,0,0,0c-.5,0-.8,0-1-.3-.3-.3-.3-.7-.3-1.4h0c0,0,0,0,0,0-.4-.1-.7-.3-.9-.6-.3-.6,0-1.4,0-1.4h-.1s-.3.8,0,1.5c.2.3.5.6.9.7,0,.7,0,1.2.3,1.5.2.3.6.4,1.1.3.4.5.9.7,1.3.7s.9-.2.9-.2h0s-1.2-4.5-1.2-4.5h-.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M35.9,21.7l.3,4.6s3.2.5,2.7-1.8c2-.9.8-2.5.8-2.5l-3.8-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M35.9,21.7l.3,4.6s3.2.5,2.7-1.8c2-.9.8-2.5.8-2.5l-3.8-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6,22s.5.6.3,1.3c-.1.4-.5.8-1.1,1.1h0s0,0,0,0c.1.6,0,1-.3,1.3-.6.6-2,.5-2.3.5l-.3-4.5h-.2s.3,4.7.3,4.7h0s.3,0,.7,0c.6,0,1.3,0,1.8-.6.3-.3.4-.8.3-1.4.6-.3,1-.7,1.1-1.2.2-.7-.3-1.4-.3-1.4h-.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M40.6,13.9c.5-.3.8-1.8-.4-1.8.9-.5.5-2.4-.7-2.3.9-1,0-2.4-1.1-2.3.6-.7-.2-2.2-1.5-1.7.4-.9-.4-1.9-1.6-1.6.6-.8-.5-2.1-1.7-1.2.4-1.3-1.4-2.1-2.2-1.2.2-1.1-1.6-1.8-2.3-.6-.7-1.2-2.2-1.1-2.5-.3-.8-1.3-2.7-.9-2.6.3-.6-.9-2.4-.9-2.3.4-.9-.9-2.5-.3-2.4.8-.9-.8-2.3,0-2,1-.8-.4-1.8.2-1.7,1.1-.8-.3-2.3.6-1.6,1.6-1.4-.5-2.2,1.1-1.5,1.8-1.2,0-1.7.9-1.3,2-1.6.2-.8,1.6-.8,1.6,0,0-1.2.9-.4,1.7-1.3.9-.2,1.9-.2,1.9,0,0-.8,1.1.2,2.2-.8,2,.8,2.1.8,2.1l29.4-.3c.8-.3,1.8-2.4.8-3.1.6-.4.9-1.7-.3-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M10.8,11.5c-.3-.4-.7-1.2.7-1.5-.3-.7-.4-1.9,1.4-2-.7-.7-.6-2.1,1.4-1.6,0,0-.6-1.1.2-1.6.8-.5,1.3.1,1.3.1,0,0-.2-1.1.4-1.4.6-.3,1.3.2,1.3.2,0,0-.3-1.2.5-1.5.6-.2,1.4.5,1.4.5,0,0-.3-1.9,1.7-1.5,0,0,.1,0,.2,0-.9-.6-2.4,0-2.2.9-.9-.8-2.3,0-2,1-.8-.4-1.8.2-1.7,1.1-.8-.3-2.3.6-1.6,1.6-1.4-.5-2.2,1.1-1.5,1.8-1.2,0-1.7.9-1.3,2-1.6.2-.8,1.6-.8,1.6,0,0-1.2.9-.4,1.7-1.3.9-.2,1.9-.2,1.9,0,0-.8,1.1.2,2.2-.6,1.5.2,1.9.6,2,0,0,0-.1,0-.1,0,0-.9-.7-.2-1.8-.6-.9-.8-1.5-.2-2.3-.6-.5-.8-1.1.3-1.8-.5-.5-.3-1.3.4-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5,14.7c0-.4-.3-.7-.7-.9.3-.3.4-.8.3-1.2,0-.3-.3-.5-.7-.6.4-.3.4-.9.3-1.4-.2-.6-.6-.9-1.1-1,.3-.5.4-1,.1-1.5-.3-.5-.8-.8-1.2-.8s0,0,0,0c.2-.4.1-.9-.2-1.3-.3-.4-.9-.6-1.4-.5.1-.4,0-.9-.3-1.2-.3-.4-.8-.5-1.3-.4.2-.4,0-.8-.3-1.1-.3-.3-.9-.5-1.5,0,0-.6-.2-1-.6-1.2-.4-.3-1.1-.3-1.6,0,0-.5-.5-.9-.9-1.1-.4-.1-1.1-.1-1.5.5-.4-.7-1.1-.9-1.6-.8-.4,0-.8.2-.9.6-.5-.7-1.2-.8-1.8-.7-.5.1-.8.5-.9.9-.4-.4-1.1-.6-1.6-.4-.4.1-.7.4-.7.9-.6-.4-1.3-.4-1.8-.1-.4.2-.6.6-.6.9-.5-.3-1.1-.2-1.5,0-.4.2-.5.6-.5,1-.4-.2-.8,0-1.2.2-.3.2-.5.6-.5,1-.5-.1-1.1,0-1.5.5-.3.3-.3.7-.2,1.1-.7-.2-1.2.2-1.5.6-.3.4-.3.9,0,1.2-.5,0-.9.3-1.1.6-.2.4-.3.9,0,1.4-.4,0-.7.3-.9.5-.2.4,0,.9,0,1.1-.2.1-.6.6-.6,1.1,0,.2,0,.5.2.6-.4.3-.6.6-.6.9,0,.5.3.9.4,1-.1.2-.6,1.3.2,2.2-.3.7-.3,1.2,0,1.6.3.5.9.5.9.5v-.2s-.5,0-.8-.4c-.2-.3-.2-.9,0-1.5h0s0,0,0,0c-.9-1-.2-2-.2-2.1h0c0,0,0-.1,0-.1,0,0-.5-.4-.4-.9,0-.3.2-.6.6-.9h0s0-.1,0-.1c-.2-.2-.2-.4-.2-.6,0-.5.6-1,.6-1h0s0,0,0,0c0,0-.3-.6-.1-1,.1-.2.4-.4.8-.5h0s0-.1,0-.1c-.2-.5-.2-1,0-1.3.2-.3.6-.5,1.2-.6h.2s-.1-.1-.1-.1c-.3-.3-.3-.8,0-1.2.2-.4.7-.7,1.5-.5h.2c0,0-.1-.1-.1-.1-.3-.5-.1-.9,0-1.1.4-.4,1-.6,1.4-.5h.1c0,0,0,0,0,0,0-.4,0-.8.4-1,.3-.2.8-.3,1.2,0h.2c0,0,0,0,0,0-.1-.4,0-.7.4-1,.3-.2.9-.4,1.5,0h.2c0,.1,0,0,0,0,0-.4.1-.7.5-.9.5-.2,1.2-.3,1.7.2h.1c0,.1,0,0,0,0,0-.6.4-.8.6-.9.6-.2,1.3,0,1.6.5l.2.2v-.3c0-.5.4-.8.7-1,.5-.2,1.3,0,1.7.7h0c0,.1,0,0,0,0,.1-.3.4-.6.9-.6.5,0,1.1.2,1.5.9h0c0,.1,0,0,0,0,.3-.6.9-.6,1.3-.5.4.1.9.5.8,1.1v.2s.1-.2.1-.2c.5-.5,1.1-.4,1.6-.2.4.2.7.7.5,1.3v.2c0,0,.1-.1.1-.1.6-.5,1.2-.3,1.5,0,.3.3.4.8.1,1.1v.2c-.1,0,0,0,0,0,.5-.2,1,0,1.3.3.3.3.4.8.2,1.2v.2c0,0,0,0,0,0,.5-.2,1.1,0,1.4.4.3.4.3.9,0,1.3v.2c-.1,0,0,0,0,0,.5,0,1,.2,1.2.7.3.5.2,1-.2,1.5h-.1c0,.1.2.1.2.1.6,0,.9.4,1.1.9.1.5,0,1.1-.4,1.3h-.2c0,.1.3.1.3.1.5,0,.7.3.7.5.1.4-.1,1-.4,1.2h-.1c0,0,.2.1.2.1.5.2.7.5.7.8,0,.4-.1.9-.5,1.1h0c0,0,0,.1,0,.1.4.3.4.7.4,1,0,.8-.7,1.7-1.2,1.9h0c.5,0,1.2-1.1,1.3-1.9,0-.5,0-.9-.4-1.1.3-.3.5-.8.4-1.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M37,16.9v6.1c1.5,1.1,4.5-.4,4.3-3.1-.2-2.7-2.1-3.9-4.3-3.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M37.1,17.9v.4c.1,0,2.6-.5,2.9,1.8.2-1.2-.7-3-2.9-2.3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M37.2,19v1.1s1.3-1.5,2,.7c.4-1.4-.9-2.5-2-1.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M37.4,21.4v.3s.9-.7,2.2.5c0,0-.8-1.3-2.2-.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M37.2,16.8v.2s2.4-.8,3.6,1.2c-.4-1.1-1.7-2-3.6-1.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M41.1,18.6c0,0,0-.1,0-.2,0,0,.7,3.5-2.1,4.3-1.2.3-1.7-.6-1.7-.6v.9c1.4,1.1,4.4-.4,4.2-3.1,0-.5-.1-.9-.3-1.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M39.9,17c-.8-.5-1.9-.6-3-.2h0c1.1-.2,2.1-.2,2.8.3.8.5,1.3,1.5,1.4,2.8.1,1.5-.8,2.6-1.7,3-.9.4-1.8.4-2.4,0h0c.6.6,1.4.6,2.2.3.1,0,.2,0,.3-.1.9-.5,1.9-1.6,1.8-3.2,0-1.3-.6-2.4-1.5-2.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M39.2,17.9c-.9-.6-2.2-.1-2.3,0h0c0,.1,0,.1,0,.1,0,0,1.3-.5,2.2,0,.5.3.8.9.9,1.8,0,1-.5,1.6-.6,1.8-.2-.2-1.3-.9-2.3-.2h0c1-.6,2.1.3,2.1.3h0s0,0,0,0c0,0,.8-.7.7-1.9,0-.9-.4-1.6-.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M38.4,18.8c-.7-.2-1.5.3-1.5.3h0c0,.1.8-.3,1.4-.1.3,0,.5.3.6.6.6,1.3-.2,1.8-.3,1.8h0c0,.1,1-.5.3-1.9-.2-.4-.4-.6-.7-.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M39.3,21.7h0c.2.3.5.7.5.7,0,0,0-.5-.4-.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M9.8,20.9c0,2.7,3,4,4.4,2.8l-.2-6.1c-2.3-.6-4.1.6-4.1,3.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M11.1,20.9c.2-2.4,2.7-2,2.7-2v-.4c-2.2-.6-3,1.2-2.7,2.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M12,21.5c.5-2.2,1.9-.8,1.9-.8v-1.1c-1.2-.7-2.4.5-1.9,1.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M11.6,23c1.2-1.3,2.2-.7,2.2-.7v-.3c-1.4-.5-2.2.9-2.2.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M10.2,19.1c1.1-2.1,3.6-1.4,3.6-1.4v-.2c-2-.4-3.2.6-3.6,1.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M12.4,23.5c-2.9-.6-2.4-4.2-2.4-4.2,0,0,0,.1,0,.2-.1.4-.2.8-.2,1.3,0,2.7,3,4,4.4,2.8v-.9s-.5,1-1.7.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M11.8,23.8c-.9-.4-1.9-1.4-1.9-2.9,0-1.3.4-2.3,1.2-2.9.7-.6,1.7-.7,2.8-.4h0c-1.1-.5-2.2-.3-3,.3-.8.6-1.3,1.7-1.3,3,0,1.6,1,2.6,2,3.1.1,0,.2,0,.3.1.8.3,1.7.1,2.2-.3h0c-.6.4-1.5.5-2.4,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M11.9,22.5c-.2-.1-.7-.7-.7-1.7,0-.9.3-1.5.8-1.9.8-.6,2.1-.2,2.2-.2h0c0-.2-1.4-.6-2.3,0-.5.4-.8,1.1-.8,2,0,1.3.8,1.9.8,1.9h0s0,0,0,0c0,0,1.1-1,2.1-.3h0c-1-.8-2,0-2.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M12.7,19.5c-.3.1-.5.4-.7.7-.5,1.4.4,2,.4,2h0c0-.1-.9-.6-.4-1.9.1-.3.3-.5.6-.6.6-.2,1.4.2,1.4.2h0c0-.1-.9-.6-1.5-.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M11.6,23.1s.2-.4.4-.6h0c-.3,0-.3.6-.3.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M28.1,31.5l-4.7.2s-.1,1.6-1.2,1.8c-1.1.1-.9,3.8,3.6,3.8s4-3.8,4-3.8c0,0-1.6.3-1.6-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M25.3,36.7c.3.3.6.4.9.6,4-.2,3.6-3.7,3.6-3.7,0,0-1.6.3-1.6-2h-1.6c-.2.2-.5.3-.7.4,0,0,2.4,3-.5,4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M29.8,33.4h0s-.5.1-1-.3c-.4-.3-.6-.9-.6-1.6h-.2c0,.8.2,1.4.6,1.8.4.3.8.3,1,.3,0,.3,0,1.5-.8,2.5-.7.8-1.7,1.1-3.2,1.1-3.1,0-4-1.7-4.1-2.7,0-.5.2-.9.5-1,1.2-.1,1.3-1.8,1.3-1.8h-.2s-.1,1.5-1.2,1.7c-.4,0-.7.5-.6,1.1,0,1,1,2.8,4.2,2.8s2.6-.4,3.3-1.2c1-1.1.8-2.6.8-2.6h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M33.9,9.1s-7.5,3.2-19.6.8c0,3.6-.5,9.4-.5,9.4,0,0-1.3,12,8.1,12.3,3.7,1.5,5.4,1.3,8,0,5.3-1.2,9-3.9,6.9-13.6,1.4-7.4-3-8.8-3-8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M14.1,19.6c-.1-.2-.2-.3-.3-.3,0,1.1-.8,11.9,8.1,12.2-8.7-.8-7.8-11.9-7.8-11.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M33.8,13.3c-1.3,1,0,1.9.4,1.9-.9.9,0,2.3.8,2.3-.9.8-.5,2.1.3,2.3.8.2,2.5,8.1-5.7,11-3.6,2.2-7.6.7-7.6.7,0,0,0,0,.2.2,3.5,1.4,5.3,1.2,7.8,0,5.3-1.2,9-3.9,6.9-13.6.5-2.7.2-4.6-.3-6l-1.9-1.5s-1.7,2.2-.9,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M33.9,9h0s0,0,0,0c0,0-7.6,3.2-19.5.8h0s0,0,0,0c0,3.6-.5,9.3-.5,9.3h0c0,0-.6,6.3,2.5,9.9,1.4,1.6,3.3,2.4,5.7,2.5,1.8.7,3.2,1.1,4.3,1.1,1.3,0,2.4-.4,3.7-1.1,3.1-.7,5.1-1.8,6.3-3.6,1.4-2.2,1.7-5.5.7-10,1.4-7.4-3-8.9-3-8.9ZM36.1,27.8c-1.2,1.8-3.1,2.9-6.2,3.6h0c-2.4,1.2-4.2,1.5-7.9,0h0c-2.4,0-4.2-.9-5.6-2.5-3.1-3.5-2.5-9.7-2.5-9.8,0,0,.6-5.7.5-9.3,11.5,2.3,19-.6,19.5-.8.4.1,4.2,1.7,2.9,8.7h0s0,0,0,0c1,4.5.7,7.7-.7,9.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M37.5,10.3s-1.4-2.1-3.6-2.3c-6.2,3.2-20.1,1.1-20.1,1.1l-1,7.9s-.4,1.1.6,1.5c-.9,2.3,1.8,1.6,1,0,1.6-.2,1.4-1.6.5-2.3,1.7-.4.6-2,.1-2.4,1.1,0,.9-1.6.4-2.2,1.4,1,2.2-.3,2.2-.3,0,0,.8,2,2.9.8.6,1.7,2.1,1.1,2.6.3.9,1.4,2.4.8,2.9,0,1,1.3,2.5.5,2.6-.4,1.2,1.3,2.4.4,2.5-.5,1.1,1,1.9.7,2.2-.5.7.8,1.6-.5,1.6-.5,0,0-1,1.6.7,2.4-.7.6-.6,1.7.4,2.1-.4.8-.2,1.8.7,2.3-1.2,1.8,1.8,3,1.2.5,1.1-.2.9-1,.6-1.7l-.9-5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M37.5,10.3s-1.4-2.1-3.6-2.3c-6.2,3.2-20.1,1.1-20.1,1.1l-1,7.9s-.4,1.1.6,1.5c-.9,2.3,1.8,1.6,1,0,1.6-.2,1.4-1.6.5-2.3,1.7-.4.6-2,.1-2.4,1.1,0,.9-1.6.4-2.2,1.4,1,2.2-.3,2.2-.3,0,0,.8,2,2.9.8.6,1.7,2.1,1.1,2.6.3.9,1.4,2.4.8,2.9,0,1,1.3,2.5.5,2.6-.4,1.2,1.3,2.4.4,2.5-.5,1.1,1,1.9.7,2.2-.5.7.8,1.6-.5,1.6-.5,0,0-1,1.6.7,2.4-.7.6-.6,1.7.4,2.1-.4.8-.2,1.8.7,2.3-1.2,1.8,1.8,3,1.2.5,1.1-.2.9-1,.6-1.7l-.9-5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M38.3,7.4c.6-.7-.2-2.2-1.5-1.7.4-.9-.4-1.9-1.6-1.6.6-.8-.5-2.1-1.7-1.2.4-1.3-1.4-2.1-2.2-1.2.2-1.1-1.6-1.8-2.3-.6,0,.1,0,.2,0,.2,0,0,1.7-.8,1.7,1.2,1.2,0,1.4,1.2.6,1.9,1.7.3,1.6,2.9-.5,3.1,1.3,2-1.2,3.6-2.5,2.6-.3,1.5-1.5,1.8-2.4.7-.5,1.4-2,1.5-2.7.2-.5,1.2-1.8,1.4-2.2,0-.9.8-2.7,1.3-3.1-.5-1.7,1-3.3,0-3.3,0,0,0,1.5,2.5-.6,3,.9.7,1.3,1.9,0,2.4,1.2,1.2-.1,2.3-.1,2.3,0,0,.4.8,0,1.6l.5-.3.2-.3c0-.2,0-.5-.1-.9,1.6-.2,1.4-1.6.5-2.3,1.7-.4.6-2,.1-2.4,1.1,0,.9-1.6.4-2.2,1.4,1,2.2-.3,2.2-.3,0,0,.8,2,2.9.8.6,1.7,2.1,1.1,2.6.3.9,1.4,2.4.8,2.9,0,1,1.3,2.5.5,2.6-.4,1.2,1.3,2.4.4,2.5-.5,1.1,1,1.9.7,2.2-.5.7.8,1.6-.5,1.6-.5,0,0-1,1.6.7,2.4-.7.6-.6,1.7.4,2.1-.4.8-.2,1.8.7,2.3-.6.9-.1,1.6.4,1.8h.6c.3-.2.4-.6.2-1.3,1.1-.2.9-1,.6-1.7,0,0,0,0,0,0-.2.8-1.2,1-1.7.4-.3-.3-.5-.9-.3-1.6-.8-.6,0-2,0-2,0,0-2-2,0-3.6,0,0,0,0,0,0,.8-.7,2.8-1.4,3,.6,0,0,0,0,.1,0,0,0,0,0-.1,0,.9-1,0-2.4-1.1-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3,16s.3.8,0,1.2c-.1.2-.3.4-.7.4h0s0,0,0,0c.2.7,0,1.1-.2,1.3-.2.1-.6,0-.8-.2-.1-.1-.5-.7,0-1.5h0c0,0,0-.1,0-.1-.8-.4-1.1-1.4-.7-2.2h0c0,0,0-.1,0-.1-.4-.2-.7-.5-.8-.9,0-.4.1-.8.4-1.1h.1c0,0-.1-.1-.1-.1-.5-.2-.8-.5-.9-.9-.2-.7.2-1.4.2-1.4h-.1c0,0-.5.6-1,.6-.2,0-.3,0-.5-.2h0c0-.1,0,0,0,0-.1.6-.4,1-.7,1.1-.4.1-.8,0-1.3-.6h-.1c0-.1,0,0,0,0,0,.4-.4.8-.8,1-.3,0-.9.2-1.5-.5h-.1c0-.1,0,0,0,0,0,.4-.5.9-1,1-.3,0-.9.1-1.5-.6h0c0,0,0,0,0,0-.2.4-.8.8-1.4.8-.4,0-.9-.1-1.4-.8h0c0-.1,0,0,0,0-.2.4-.8.8-1.4.8-.5,0-.9-.4-1.1-1h0c0,0,0,0,0,0-.6.4-1.2.5-1.7.3-.7-.3-1.1-1-1.1-1h0c0-.1,0,0,0,0,0,0-.3.5-.8.6-.4,0-.8,0-1.2-.3h0c.3.4.5,1.2.3,1.7-.1.3-.3.4-.7.4h-.2s.2.1.2.1c.3.3.8,1,.7,1.6,0,.3-.3.5-.8.7h-.1s.1.1.1.1c.5.4.7,1,.6,1.5-.1.4-.5.6-1.1.7h-.1s0,.1,0,.1c.4.7,0,1.1-.1,1.2-.2.2-.5.2-.7.1-.3-.2-.3-.7,0-1.3h0c0,0,0,0,0,0-.3,0-.4-.3-.5-.5-.2-.4,0-.9,0-1,0,.2-.2.6,0,1,0,.2.3.4.5.5-.3.9,0,1.3.1,1.4.1,0,.2.1.3.1.2,0,.4,0,.6-.2.3-.2.5-.7.2-1.3.6-.1,1-.4,1.1-.8.1-.5,0-1.1-.6-1.5.5-.1.7-.4.8-.7.1-.6-.3-1.2-.6-1.6.3,0,.5-.2.6-.5.2-.4,0-1.1-.1-1.5.4.2.7.2,1,.2.4,0,.7-.4.8-.6.1.2.5.8,1.1,1,.5.2,1.1,0,1.7-.3.3.8.8,1,1.2,1.1.6,0,1.2-.3,1.5-.7.5.7,1,.8,1.4.8.6,0,1.2-.4,1.5-.8.4.5,1,.7,1.6.6.5-.1.9-.5,1.1-1,.7.7,1.3.6,1.6.5.4-.1.8-.5.9-1,.5.5,1,.6,1.4.5.4-.1.6-.5.8-1,.2.1.3.2.5.2.3,0,.5-.2.7-.4,0,.3-.1.6,0,1,.1.4.4.7.9.9-.3.3-.5.7-.4,1.1,0,.4.4.8.8,1-.4.8,0,1.8.7,2.3-.4.7-.2,1.3,0,1.6.3.3.7.4,1,.3.2-.1.5-.4.3-1.4.4,0,.6-.3.7-.5.2-.4,0-.9-.2-1.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M21.1,26.3h0c0,.2,2.2,1,4.9,1s2.9-.2,4.3-.9h0c-4.3,1.8-9.1-.1-9.1-.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M29.8,26.6c-3.2,1.2-6.6.5-8,0,0,.8.7,3.4,4.1,3.4s3.9-3.4,3.9-3.4h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M25.9,29.3c-1.1-1.3-2-.4-2.4.1.6.3,1.3.6,2.3.6s1.6-.2,2.2-.5c-.6-1-1.3-1.3-2.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M25.9,29.3c-1.1-1.3-2-.4-2.4.1,0,0,0,0,0,0,.1,0,.3.2.4.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.7-1,1.8,0,.8-.7,1.3-.5,1.7.1.2,0,.3-.1.5-.2-.6-1-1.3-1.3-2.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M27,28.6c-.4,0-.7.2-1.1.6-.4-.5-.8-.7-1.2-.6-.6,0-1,.5-1.2.9h0c0,0,0,.1,0,.1.6.4,1.4.6,2.4.6s1.6-.2,2.2-.5h0s0-.1,0-.1c-.3-.6-.7-.9-1.1-1ZM25.9,30c-.9,0-1.6-.2-2.2-.5.2-.3.6-.7,1-.7.4,0,.8.2,1.2.7h0c0,0,0,0,0,0,.4-.5.7-.7,1-.6.3,0,.6.3,1,.8-.6.3-1.3.4-2.1.4Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "25.9 29.7 26 29.3 25.9 29.3 25.9 29.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M29.8,26.5h0c-3.2,1.3-6.6.5-7.9,0h-.1s0,0,0,0c0,.8.7,3.5,4.2,3.5s2.4-.4,3.1-1.1c1-1,.9-2.4.9-2.4h0ZM28.8,28.9c-.7.7-1.7,1-2.9,1-3.2,0-3.9-2.3-4-3.2,1.4.4,4.7,1.1,7.8,0,0,.3,0,1.4-.9,2.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M20.9,26.4c0,.3.2.6.2.6-.1-.2-.1-.4,0-.5.1-.4.7-.5.7-.5,0,0-.5,0-.7.3,0,0,0,.1-.1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M29.7,25.9s.6.2.4,1.1c0,0,.2-.3.1-.7-.1-.4-.6-.4-.6-.4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M27.2,23.8l-2.7-1.6s.5,1.1-.2,1.7c-.7-.6-1.5.1-1.4,1.1s1.3.8,1.6.4c.7,1.2,2.1.7,2.6.1.7.6,1.6-.2,1.6-.8s-.6-1.3-1.4-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M27.1,25.5c.7.6,1.6-.2,1.6-.8s0-.5-.2-.7c-.1,0-.2,0-.2,0,.3.8-.6,1.4-1.2,1-.6.7-1.7,1.1-2.4-.1-.7.5-1.5.5-1.6-.2,0,0,0,0,0-.1,0,.1,0,.3,0,.5,0,1,1.3.8,1.6.4.7,1.2,2.1.7,2.6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M28.2,23.8c-.4-.3-.9,0-.9,0,.4-.2.6,0,.8,0,.3.2.5.5.5.8s-.3.7-.6.8c-.2,0-.5.2-.8-.1h0s0,0,0,0c-.3.3-.8.6-1.4.6-.4,0-.8-.3-1.1-.7h0c0,0,0,0,0,0-.2.2-.7.4-1.1.3-.3,0-.4-.3-.4-.6,0-.5.2-1,.5-1.2.2-.1.5,0,.8.1h0s0,0,0,0c.8-.6.3-1.8.3-1.8,0,0,.3,1.1-.3,1.6-.3-.2-.6-.2-.9,0-.4.2-.6.7-.6,1.3,0,.4.2.6.5.7.4.1.9,0,1.2-.2.3.5.8.7,1.1.7,0,0,0,0,.1,0,.6,0,1.1-.3,1.4-.6.3.2.6.2.9,0,.4-.2.7-.6.7-1s-.2-.7-.5-1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M24.2,23.9h.1c.6-.7,1.4-.4,1.4-.3,0,0-.8-.6-1.5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M24,30.7s.8.4,1.8.5c0,0,0,0,.1,0,1,0,1.5-.5,1.5-.5-1.4.7-3.4,0-3.4,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M14.6,34.1c-2.5,0-5.8.9-5.9.9s-.8-1.6-5.6-.2c-1,.4-.5.9,0,.9.3,0-.2,1.6,1,2.2.8.4,3.1-.2,4,.1.4.1.9.2,1.3.3,2.7.4,5,.4,6.8-.2.6-.1,2.7.7,4.4-.2l-.3-4.4s-3.2.5-5.7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2.6,35.3s0,0,0,0c0,.2,0,.3.2.4.6,0,1.4-.3,1.8-.6-.6-.1-2,.2-2,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M16.4,36.9c-2.2.5-5.3.9-7.2.5-.3,0-.9,0-1,.2-.2.3-.3.4-.5.5.2,0,.3,0,.4,0,.4.1.9.2,1.3.3,2.7.4,5,.4,6.8-.2.6-.1,2.7.7,4.4-.2v-2.1c-.2,0-.2,0-.2,0,0,0-1.8,1-4,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M17.1,38.2c-.4,0-.7-.1-.9,0-1.6.5-3.8.6-6.7.2-.4,0-.8-.2-1.3-.3-.4-.1-1.1,0-1.9,0-.8,0-1.7.1-2.1,0-.8-.4-.9-1.3-.9-1.8,0-.3,0-.5-.2-.5-.2,0-.4-.1-.5-.3,0-.2.1-.4.5-.5,2.8-.8,4.7-.7,5.5.2,0,0,0,0,.1,0s0,0,.3,0c2.3-.5,4.2-.8,5.6-.8,2.5,0,5.7-.6,5.7-.6v-.2c0,0-3.2.5-5.7.6-1.4,0-3.3.3-5.7.8,0,0-.2,0-.2,0,0,0,0,0,0,0-.8-1-2.8-1-5.7-.2-.6.2-.6.5-.6.7,0,.2.3.4.6.4,0,0,0,.2,0,.3,0,.5,0,1.5,1,1.9.4.2,1.3.2,2.2.1.7,0,1.5-.1,1.9,0,.5.1.9.2,1.3.3,1.2.2,2.4.3,3.4.3s2.5-.2,3.4-.5c.2,0,.5,0,.9,0,.9.1,2.3.4,3.6-.2h0c-1.2.5-2.6.2-3.5,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M1.1,37c.7-.2,2.5-.6,2.5-.6l1-1.3s-4.8.9-3.5,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M3.6,36.4v-.2c-.9-.1-2,.4-2.7.5,0,0,0,0,0,0,0,.1,0,.2.2.3.7-.2,2.3-.6,2.5-.6,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M4.6,35.1s-3.5.5-3.8,1.5c0,.2,0,.4.3.5h0s0,0,0,0c.7-.2,2.5-.6,2.5-.6h0c0-.1-1.7.3-2.5.5-.1-.1-.2-.2-.2-.4.2-.7,2.7-1.3,3.7-1.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M.1,37.9c.3.4,1.2.4,3.8-.6v-1.1c-.1,0-4.3,1.1-3.8,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M4.1,37.1c-1.4,0-3.1.8-3.9.8,0,0,0,0,0,0,0,0,0,0,0,0,.3.4,1.1.4,3.4-.5.1,0,.3-.1.4-.2h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M.2,37.9s0,0,0-.1c.2-.5,2.7-1.3,3.6-1.6,0,0-3.5.7-3.8,1.5,0,0,0,.2,0,.3.1.2.4.3.7.3.6,0,1.5-.2,3.1-.9h0c-2.3.7-3.3.9-3.7.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M.9,38.9c.2.6,2.9-.3,4.7-.8l-1.5-1s-3.6.7-3.2,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M.9,39c.5.4,2.7-.3,4.4-.8,0,0,.1,0,.2-.1l.3-.4c-1.2,0-3.2.6-4.9,1.2,0,0,0,0,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M4.6,38.3c-1.5.4-3.5.9-3.6.5,0-.1,0-.3,0-.4.5-.8,3.1-1.4,3.1-1.4,0,0-2.7.4-3.2,1.3,0,.2-.1.3,0,.5,0,.2.3.2.6.2.7,0,1.8-.3,3.2-.7.3,0,.7-.2,1-.3h0c-.3,0-.6,0-1,.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M5.8,37.7s-2.5.6-2.2,1.7c.2.7,1.9,0,2.9-.2,1.1-.1,2.3-1.1,2.2-1.8l-2.9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M8.4,38.1c-.3.5-1.1.9-1.8,1-.3,0-.7.1-1.1.2-.8.2-1.6.4-1.7,0,0-.2,0-.3,0-.5.4-.7,2-1.2,2-1.2,0,0-1.7.3-2.1,1.1-.1.2-.2.4,0,.6,0,.3.3.4.6.4s.8-.1,1.3-.2c.4,0,.7-.2,1.1-.2.8,0,1.5-.6,1.9-1.1.2-.3.3-.5.3-.7,0,0-.2.4-.4.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "14.1 64.6 18.6 64.9 18.7 61.5 15.1 60.9 14.1 64.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M18.7,61.5l-2-.3s.3,2.2-.6,2.9c.5.5,1.6.7,2.5.6v-3.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "18.5 64.8 14.2 64.5 15.1 60.9 15 60.8 14 64.7 18.6 65 18.8 61.5 18.6 61.5 18.5 64.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M18.7,63.1s-1.7,1.8-4.3.5c-1.3-1.1-2.8.7-5.3.7s-3,2.6-2.6,4.4c.2.2,6.6,1.7,13.6-.3.4-.3-.5-5.6-1.3-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M20,68.4c.4-.3-.5-5.6-1.3-5.3,0,0-.9.9-2.4,1,0,0,0,0,0,0,0,0,3,5.6-9.8,4.5,0,0,0,0,0,.1,1,.4,6.9,1.5,13.5-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M18.7,63h0s0,0,0,0c0,0-1.7,1.7-4.2.5-.8-.6-1.6-.3-2.6,0-.8.3-1.7.6-2.8.6s-1.5.3-2,.9c-.8,1-.9,2.5-.7,3.6h0c.1.2,2.5.8,6,.8s4.9-.2,7.7-1h0c.4-.3-.3-3.9-.8-5-.2-.4-.4-.5-.5-.5ZM19.9,68.4c-6.8,1.9-13.1.6-13.5.3-.2-1.1-.1-2.5.7-3.5.5-.5,1.1-.8,1.9-.8s2-.3,2.8-.7c1-.4,1.8-.7,2.5,0h0c2.5,1.2,4.2-.3,4.4-.5,0,0,.2.1.3.3.6,1.2,1.1,4.6.9,4.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M18.7,64.6l.6,2.9c.3,0,.4-.2.8-.3,0-.8-.3-1.9-.5-2.8l-.8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M18.7,64.6l.6,2.9c.3,0,.4-.2.8-.3,0-.8-.3-1.9-.5-2.8l-.8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M19.5,64.4h0c0,0-.9.1-.9.1l.6,3h0c.3-.1.5-.2.8-.3h0s0,0,0,0c0-.9-.3-2-.5-2.8ZM19.3,67.4l-.5-2.7h.6c.2.6.4,1.7.5,2.5-.2,0-.4.1-.6.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M11.1,64.9c-1,0-1.1,1.3-.8,1.5.3.2,4.6-.2,5.4-2.4h0c-.4,0-.9-.2-1.3-.4,0,0-1,1.2-3.3,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M15.7,64h0c-.2,0-.4,0-.6-.1h0s-.8,2-4.8,2.1c0,0,0,0-.1,0,0,.2,0,.4.2.4.3.2,4.6-.2,5.4-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M14.4,63.5h0s0,0,0,0c0,0-1,1.2-3.2,1.3-.6,0-.9.5-1,.9,0,.3,0,.6.2.7,0,0,.2,0,.4,0,.6,0,2-.2,3.2-.7,1.1-.4,1.7-1,2-1.8h0c0-.1,0-.1,0-.1-.4,0-.9-.2-1.3-.4ZM13.7,65.7c-1.5.6-3.2.7-3.4.6,0,0-.1-.3,0-.5,0-.4.3-.8.8-.8h0c2-.1,3.1-1.1,3.3-1.3.4.2.8.3,1.2.4-.3.7-.9,1.2-1.9,1.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M13.2,62.9c-.4,0,0,.9,0,.9.2.6.5,1.3,1,1,.5-.3-.4-2.1-.9-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M13.2,62.9c-.3.1,0,.9,0,.9.2.6.4,1.1.8,1.1,0,0,0,0,0,0-.5-.5-.8-1.8-.8-1.8,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M13.2,62.8c0,0-.2,0-.2.1-.2.3,0,.8,0,.9h0c.2.5.4,1,.7,1.1,0,0,.1,0,.2,0,0,0,.2,0,.2,0,.2-.1.3-.5,0-1-.2-.5-.6-1.2-1-1.1ZM14.1,64.8c-.1,0-.2,0-.3,0-.3,0-.4-.5-.6-1,0-.2-.2-.6,0-.8,0,0,0,0,0,0,.2,0,.6.4.9,1,.1.4.1.7,0,.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M13.2,61.6c-.8.2-1.7,1-.7,1.8.7.6,1.1-.1,1.6,0,.4.1.7.3.7.3.6-1.3-.8-2.3-1.6-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M13.8,61.7s0,0,0,0c0,0,1.1,1.2-1.1,1.7,0,0,0,0,0,0,.6.4,1-.2,1.5,0,.4.1.7.3.7.3.4-1-.2-1.8-.9-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M13.1,61.6c-.5.1-1.1.5-1.2,1,0,.2,0,.6.5,1,.4.4.8.3,1.1.1.2,0,.4-.1.5,0,.4.1.6.3.6.3h0s0,0,0,0c.2-.6.2-1.2-.2-1.7-.4-.5-1-.7-1.4-.6ZM14.7,63.7c-.1,0-.3-.2-.6-.3,0,0-.1,0-.2,0-.1,0-.3,0-.4,0-.3.1-.6.2-1-.1-.4-.3-.5-.5-.4-.8,0-.4.6-.7,1.1-.8.4,0,1,.1,1.3.5.2.2.5.7.2,1.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M10.7,63.6c-.4,0-.3.9-.3.9,0,.7.2,1.3.8,1.2.5-.2,0-2.1-.5-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M10.6,63.6c-.4,0-.2.9-.2.9,0,.6.2,1.2.6,1.2,0,0,0,0,0,0-.4-.5-.4-2-.4-2,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M10.7,63.5c0,0-.2,0-.2.1-.2.2-.1.8-.1.9h0c0,.5.2,1,.5,1.2,0,0,.2,0,.2,0s.1,0,.2,0c.2,0,.3-.4.3-.9,0-.5-.4-1.3-.8-1.3ZM11.1,65.6c-.1,0-.2,0-.3,0-.2-.1-.3-.6-.4-1.1,0-.2,0-.6,0-.8,0,0,0,0,.1,0,.2,0,.5.6.6,1.2,0,.4,0,.7-.2.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M12,63.3c-.4,0-.2.9-.2.9.2.6.4,1.3.9,1.1.5-.2-.1-2.1-.7-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M12,63.3c-.3,0-.2.9-.2.9.1.6.3,1.2.7,1.2,0,0,0,0,0,0-.4-.5-.5-1.9-.5-1.9,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M12,63.2c0,0-.2,0-.2.1-.2.3,0,.8,0,.9h0c.1.5.3,1,.6,1.2,0,0,.1,0,.2,0s.1,0,.2,0c.2,0,.3-.4.2-.9-.1-.5-.5-1.3-.9-1.2ZM12.7,65.2c-.1,0-.2,0-.3,0-.2-.1-.4-.6-.5-1.1,0-.2-.1-.6,0-.8,0,0,0,0,.1,0,.2,0,.6.5.7,1.1,0,.4,0,.7,0,.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M18.7,63.1s-.5.5-1.3.8c.2.5.7,1.3,2.2,1-.3-1-.6-1.8-.9-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M18.7,63.1s-.5.5-1.3.8c.2.5.7,1.3,2.2,1-.3-1-.6-1.8-.9-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M18.9,63.1c0,0-.1,0-.2,0h0s0,0,0,0c0,0-.5.5-1.2.7h0s0,0,0,0c.2.5.6,1.1,1.6,1.1s.4,0,.7,0h0s0,0,0,0c-.2-.7-.5-1.6-.8-1.8ZM17.5,63.9c.7-.3,1.1-.6,1.2-.7,0,0,0,0,0,0,.2.1.5.7.7,1.6-1.3.3-1.8-.4-2-.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M6.4,68.7c0,0,1,.4,2.6.5,1.5-2.3,0-4.9,0-4.9-2.5,0-3,2.6-2.6,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M9,64.3s0,0-.1,0c0,0,0,0,0,0,0,0,.9,2.6-.3,3.8-.4.4-.4.7-.3.9.2,0,.4,0,.7,0,1.5-2.3,0-4.9,0-4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M9.1,64.2h0c-.9,0-1.5.3-2,.9-.8,1-.9,2.5-.7,3.6h0c.1.2,1.3.4,2.6.6h0s0,0,0,0c1.5-2.3,0-5,0-5h0ZM8.9,69.2c-1.5-.2-2.4-.4-2.5-.5-.2-1.1-.1-2.5.7-3.5.4-.5,1.1-.8,1.9-.8.2.3,1.2,2.7,0,4.8Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M20,67.2l-.9.3c-6.8,2.2-12.8,0-12.8,0,0,.4,0,.8,0,1.1.2.2,6.6,1.7,13.6-.3,0,0,.1-.3,0-.7v-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M20,67.2l-.9.3c-2,.6-3.8.9-5.5,1-.1,0-.2,0-.3,0-3,.7-6.8,0-6.8,0,0,0,0,0,0,0,.6.3,6.8,1.6,13.5-.3,0,0,.1-.3,0-.7v-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M20.1,67.1l-1,.4c-6.7,2.2-12.7,0-12.8,0h-.1s0,0,0,0c0,.4,0,.8,0,1.2h0c.1.2,2.5.8,6,.8s4.9-.2,7.7-1h0c0,0,.1-.2.1-.8v-.6ZM19.9,68.4c-6.8,1.9-13.1.6-13.5.3,0-.3,0-.7,0-1,.8.3,6.5,2,12.8,0l.8-.3v.4c0,.5,0,.6,0,.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "38.6 64.7 34.1 65.3 33.8 61.8 37.4 61 38.6 64.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M33.8,61.8l2-.5s-.2,2.2.8,2.9c-.5.5-1.5.7-2.5.7l-.3-3.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "34.2 65.2 38.5 64.6 37.3 61.1 37.5 61 38.7 64.8 34.1 65.4 33.8 61.9 33.9 61.8 34.2 65.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M33.9,63.5s1.8,1.7,4.3.2c1.2-1.2,2.9.6,5.4.4,2.5-.1,3.1,2.4,2.9,4.3-.2.3-6.5,2-13.6.5-.4-.2.2-5.6,1-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M32.9,68.9c-.4-.2.2-5.6,1-5.4,0,0,1,.9,2.4.8,0,0,0,0,0,0,0,0-2.7,5.8,10.1,4,0,0,0,0,0,.1-.9.4-6.9,1.8-13.5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M33.4,63.9c-.5,1.2-.9,4.8-.5,5h0c2.8.6,5.5.7,7.7.6,3.5-.2,5.8-.9,5.9-1.1h0c.1-1.1,0-2.7-.9-3.6-.5-.6-1.2-.8-2.1-.8-1.1,0-2-.2-2.8-.5-1.1-.3-1.9-.6-2.6,0-2.4,1.4-4.2-.2-4.2-.2h0s0,0,0,0c-.2,0-.4.1-.5.5ZM33.6,63.9c0-.2.2-.3.3-.3.2.2,2,1.6,4.4.2h0c.7-.6,1.5-.4,2.5,0,.8.3,1.7.6,2.8.5.8,0,1.5.2,2,.7.8.9,1,2.3.9,3.4-.4.3-6.5,1.9-13.5.4-.2-.2,0-3.7.6-4.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M34,65l-.4,2.9c-.3,0-.5-.1-.8-.2,0-.8.2-1.9.4-2.8h.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M34,65l-.4,2.9c-.3,0-.5-.1-.8-.2,0-.8.2-1.9.4-2.8h.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M32.7,67.7h0c0,0,0,0,0,0,.3,0,.5.1.8.2h0s.4-3.1.4-3.1l-.9-.2h0c-.2.9-.3,2-.4,2.9ZM32.9,67.6c0-.9.2-1.9.4-2.7h.6c0,.1-.4,2.9-.4,2.9-.2,0-.4-.1-.6-.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M41.6,64.9c1,0,1.2,1.2.9,1.4-.3.2-4.6,0-5.5-2.1h0c.4,0,.9-.2,1.3-.5,0,0,1.1,1.2,3.3,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M36.9,64.2h0c.2,0,.4,0,.6-.2h0s.9,1.9,4.9,1.8c0,0,0,0,.1,0,0,.2,0,.4-.1.4-.3.2-4.6,0-5.5-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M36.9,64.2h0s0,0,0,0h0c.3.7,1,1.3,2.1,1.7,1.2.4,2.5.5,3.2.5.2,0,.3,0,.4,0,.2,0,.2-.4.1-.7-.1-.4-.4-.8-1-.8-2.2,0-3.3-1.1-3.3-1.1h0s0,0,0,0c-.4.2-.9.4-1.3.5ZM37.1,64.3c.4,0,.8-.2,1.2-.5.2.2,1.3,1.1,3.3,1.1h0c.5,0,.8.4.9.7,0,.3,0,.5,0,.5-.2,0-1.9.1-3.4-.4-1-.4-1.6-.9-1.9-1.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M39.4,63c.4,0,.1.9.1.9-.2.6-.4,1.3-.9,1.1-.5-.2.2-2.1.8-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.3,63c.3.1.1.9.1.9-.2.6-.4,1.2-.8,1.1,0,0,0,0,0,0,.5-.5.7-1.9.7-1.9,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M38.4,64.1c-.1.5,0,.8.1.9,0,0,.2,0,.3,0,0,0,.1,0,.2,0,.3-.1.5-.6.6-1.1h0c0,0,.2-.6,0-.9,0,0-.1-.1-.2-.1-.4,0-.8.7-1,1.2ZM38.6,64.1c.2-.6.6-1.1.8-1.1,0,0,0,0,.1,0,.1.2,0,.6,0,.8-.1.5-.3.9-.5,1,0,0-.2,0-.3,0-.1,0-.2-.4,0-.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M39.3,61.7c.8.1,1.8.9.8,1.7-.7.6-1.1,0-1.6.2-.4.2-.6.3-.6.3-.6-1.3.6-2.4,1.5-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M38.7,61.8s0,0,0,0c0,0-1,1.2,1.2,1.6,0,0,0,0,0,0-.6.4-1-.1-1.5,0-.4.2-.6.3-.6.3-.5-1,.1-1.8.8-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M37.9,62.3c-.4.5-.4,1.1-.1,1.7h0c0,0,0,0,0,0,0,0,.3-.2.6-.3.2,0,.3,0,.5,0,.3,0,.7.2,1.1-.2.5-.4.5-.8.4-1-.1-.5-.7-.8-1.2-.9-.5,0-1.1.2-1.4.7ZM38.1,62.4c.3-.4.8-.7,1.3-.6.5,0,1,.4,1.1.8,0,.3,0,.6-.4.8-.4.3-.6.3-.9.2-.1,0-.3,0-.4,0,0,0-.1,0-.2,0-.3.1-.5.2-.6.3-.3-.7,0-1.2.2-1.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M42,63.5c.4,0,.3.9.3.9,0,.7-.2,1.4-.7,1.2-.5-.1-.2-2.1.4-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42,63.6c.4,0,.3.9.3.9,0,.6-.1,1.2-.6,1.2,0,0,0,0,0,0,.4-.6.3-2,.3-2,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M41.2,64.8c0,.5,0,.8.3.9,0,0,.1,0,.2,0,0,0,.2,0,.2,0,.3-.2.3-.7.4-1.2h0c0,0,0-.7-.2-.9,0,0-.1,0-.2,0-.4,0-.7.8-.7,1.4ZM41.4,64.8c0-.6.3-1.2.6-1.2,0,0,0,0,.1,0,.1.1.1.6.1.8,0,.5-.1,1-.3,1.1,0,0-.2,0-.3,0-.2,0-.2-.3-.2-.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M40.6,63.3c.4,0,.2.9.2.9-.1.6-.3,1.3-.8,1.2-.5-.2,0-2.1.6-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.6,63.3c.4,0,.2.9.2.9,0,.6-.2,1.2-.6,1.2,0,0,0,0,0,0,.4-.5.4-2,.4-2,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M39.8,64.5c0,.5,0,.8.2.9,0,0,.1,0,.2,0,0,0,.1,0,.2,0,.3-.2.4-.7.5-1.2h0c0,0,.1-.6,0-.9,0,0-.1-.1-.2-.1-.4,0-.7.8-.8,1.3ZM39.9,64.5c.1-.6.4-1.2.7-1.2,0,0,0,0,.1,0,.1.2,0,.6,0,.8,0,.5-.2.9-.4,1.1,0,0-.2,0-.3,0-.2,0-.2-.3-.1-.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M33.9,63.5s.5.4,1.3.7c-.2.5-.7,1.4-2.1,1.1.2-1,.5-1.9.8-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33.9,63.5s.5.4,1.3.7c-.2.5-.7,1.4-2.1,1.1.2-1,.5-1.9.8-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M33,65.3h0c0,0,0,0,0,0,.2,0,.5,0,.7,0,1,0,1.4-.8,1.5-1.2h0c0,0,0,0,0,0-.8-.2-1.3-.7-1.3-.7h0s0,0,0,0c0,0-.1,0-.2,0-.3.2-.5,1.1-.7,1.8ZM33.2,65.2c.2-.9.4-1.5.6-1.6,0,0,0,0,0,0,0,0,.5.4,1.2.7-.2.5-.6,1.2-1.9,1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M46.5,68.4c0,0-1,.4-2.5.7-1.6-2.2-.3-4.9-.3-4.9,2.5-.1,3.1,2.4,2.9,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M43.6,64.1s0,0,.1,0c0,0,0,0,0,0,0,0-.7,2.7.5,3.8.4.4.5.7.3.9-.2,0-.4,0-.7.1-1.6-2.2-.3-4.9-.3-4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M43.6,64.1s-1.2,2.8.4,5h0s0,0,0,0c1.3-.2,2.5-.6,2.6-.7h0c.1-1.2,0-2.7-.9-3.6-.5-.6-1.2-.8-2.1-.8h0s0,0,0,0ZM43.7,64.2c.8,0,1.4.2,1.9.7.8.9,1,2.3.9,3.4-.1,0-.9.4-2.4.6-1.4-2-.5-4.4-.3-4.8Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M32.8,67.7l.9.3c6.9,1.9,12.8-.7,12.8-.7,0,.4,0,.8,0,1.2-.2.3-6.5,2-13.6.5,0,0-.1-.3-.1-.7v-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.8,67.7l.9.3c2,.5,3.9.7,5.6.7.1,0,.2,0,.3,0,3.1.6,6.8-.3,6.8-.3,0,0,0,0,0,0-.6.3-6.7,1.9-13.5.4,0,0-.1-.3-.1-.7v-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M32.7,68.2c0,.6,0,.7.2.8h0c2.8.6,5.5.7,7.7.6,3.5-.2,5.8-.9,5.9-1.1h0c0-.4,0-.8,0-1.2h0c0-.1,0,0,0,0,0,0-5.9,2.5-12.8.7l-1-.3v.6ZM32.9,68.2v-.4s.8.2.8.2c6.4,1.7,12-.3,12.8-.6,0,.3,0,.7,0,1-.4.3-6.5,1.9-13.5.4,0,0,0-.1,0-.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M18,46.7s-2.9,11.4-4.5,13.6c-.4.7,4.5,2.6,6.9,2.1.3-.3,1.6-5.6,3.5-8.5.8-1.3.9-2,.9-2h1.9s2.1,3.9,3,5.6c.9,1.8,2,5.5,2,5.5,0,0,3.8,0,7-2.5-.8-2.1-5-8.8-5.6-13.4,0,0-9.5,3-15.1-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M37.3,57.4c-1.6-3-3.7-7.2-4.1-10.4h0c0,0,0,0,0,0,0,0-9.6,3-15.1-.3h0c0,0,0,0,0,0,0,.1-2.9,11.4-4.5,13.6,0,0,0,.2,0,.4.6.8,4.8,2.3,6.9,1.8h0s0,0,0,0c.1-.1.3-.6.7-1.7.6-1.8,1.6-4.9,2.9-6.8.6-1.1.9-1.8.9-2h1.8c.2.4,2.1,3.9,3,5.6.9,1.7,2,5.4,2,5.5h0c0,0,0,0,0,0h0c.1,0,3.9,0,7-2.5h0s0,0,0,0c-.2-.7-.8-1.7-1.5-3ZM31.8,62.9c-.1-.5-1.2-3.8-2-5.4-.9-1.7-3-5.6-3-5.6h0s-2,0-2,0h0c0,0-.2.7-.9,2-1.3,2-2.3,5.1-2.9,6.9-.3.8-.5,1.5-.6,1.6-2.1.5-6.1-1-6.7-1.8,0,0,0-.1,0-.2,1.5-2.1,4.2-12.4,4.5-13.6,5.3,3.1,14,.6,15,.3.5,3.2,2.6,7.3,4.1,10.3.7,1.3,1.2,2.3,1.4,3-2.9,2.3-6.3,2.4-6.8,2.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M13.5,60.3c-.1.2.4.7,1.3,1,.2-.7,1-3.1,2.1-5.5,1.2-2.5,2-7.6,2.1-8.7-.4-.2-.7-.3-1-.5,0,0-2.9,11.4-4.5,13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M18,46.6h0c0,0,0,0,0,0,0,.1-2.9,11.4-4.5,13.6,0,0,0,.1,0,.2.1.3.9.7,1.3.9h0s0,0,0,0c.2-.7,1-3.1,2.1-5.5,1.2-2.5,2-7.7,2.1-8.7h0c0,0,0,0,0,0-.4-.2-.7-.3-1-.5ZM16.8,55.9c-1.1,2.3-1.9,4.6-2.1,5.4-.7-.3-1.1-.6-1.1-.8,0,0,0,0,0,0,1.5-2.1,4.2-12.4,4.5-13.6.3.2.6.3.9.5-.2,1.1-.9,6.1-2.1,8.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M23.2,51.5s1.2.4,1.9.5v-.2c-.7,0-1.9-.3-1.9-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M26.6,51.8v.2s0,0,0,0c.7,0,1.4-.2,1.5-.3,0,0-.9.1-1.5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M16.4,55.1c-1.4,2.9-2.3,5.9-2.3,6h.1s.9-3,2.3-5.9c1.4-2.9,1.8-8.2,1.8-8.3h-.2s-.4,5.3-1.8,8.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M31.5,47.5c.7,2.1,2.8,8.5,6.1,13.8.4-.2.7-.5,1.1-.8-.8-2.1-5-8.8-5.6-13.4,0,0-.6.2-1.6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M37.3,57.4c-1.6-3-3.7-7.2-4.1-10.4h0c0,0,0,0,0,0,0,0-.6.2-1.6.4h0s0,0,0,0c.8,2.4,2.8,8.5,6.1,13.8h0c0,0,0,0,0,0,.4-.2.8-.5,1.1-.8h0s0,0,0,0c-.2-.7-.8-1.7-1.5-3ZM37.6,61.1c-3.2-5.2-5.2-11.2-6-13.6.7-.2,1.2-.3,1.4-.4.5,3.2,2.6,7.3,4.1,10.3.7,1.3,1.2,2.3,1.4,3-.3.2-.6.5-1,.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M32.4,47.2c0,0,2.6,8.8,5.8,13.6h.1c-3.2-4.9-5.7-13.6-5.8-13.7h-.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M31.5,33.6s-2.4,8.3.7,8.7c3.1.4,5.6-1.4,3.8-4.4-2.3-3.8-4.5-4.3-4.5-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M31.5,33.6s0-.1-.1.5c1.6.6,4.6,3.9,3.8,6-.4,1-2.3,1.2-4.2,1.2.2.5.6.9,1.2.9,3.1.4,5.6-1.4,3.8-4.4-2.3-3.8-4.5-4.3-4.5-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M31.5,33.5h0s0,0,0,0c0,.2-1.7,6-.4,8,.3.4.6.7,1.1.7.3,0,.6,0,.8,0,1.4,0,2.7-.5,3.3-1.4.6-.9.5-2-.2-3.2-2.3-3.8-4.4-4.3-4.5-4.3ZM36.1,40.9c-.7,1-2.2,1.5-4,1.3-.4,0-.8-.3-1-.6-1.2-1.9.2-7.2.4-7.8.4.1,2.3.9,4.3,4.2.7,1.2.8,2.2.2,3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M33.1,45.3c-.7-1.4-.8-6-.8-7.2-1.6-1.2-.5-4.4-.9-4.9-.4-.5-2.2-.4-2.2-.4,0,0,.5,3.9-3.2,3.9-3.8,0-3.4-3.9-3.4-3.9-.9-.4-2.4,0-2.4.5.8,4-1.2,6.2-1.2,6.2,0,0,.1,3.9-.9,5.7-1.9.8-.5,3,3.9,3.5,4.4.5,8,.2,10-.6s2.3-2.7,1.2-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M33.2,45.2c-.8-1.5-.8-6.9-.8-7.1h0s0,0,0,0c-1.1-.7-.9-2.4-.8-3.6,0-.6,0-1.1,0-1.3-.4-.5-2.2-.4-2.3-.4h0s0,0,0,0c0,0,.2,1.8-.7,2.9-.5.6-1.3.9-2.4.9-1,0-1.9-.3-2.4-.9-1-1.1-.9-2.9-.9-2.9h0c0,0,0,0,0,0-.7-.3-1.7-.1-2.2.2-.2.1-.3.3-.3.4h0s0,0,0,0c.8,3.9-1.1,6.1-1.1,6.2h0s0,0,0,0c0,0,.1,3.9-.9,5.6-.6.3-.9.7-.8,1.2.1.9,1.7,2.1,4.8,2.5,1.4.2,2.7.3,4,.3,2.4,0,4.5-.3,6-.8,1.4-.5,1.9-1.5,1.9-2.2,0-.4-.3-.8-.7-.9ZM31.9,48.2c-2.4.8-6.1,1-10,.6-2.9-.4-4.5-1.5-4.7-2.4,0-.4.2-.8.8-1h0s0,0,0,0c1-1.7,1-5.3,1-5.7.2-.3,1.9-2.5,1.1-6.3,0,0,0-.2.2-.3.4-.3,1.4-.4,2-.2,0,.3,0,1.9.9,3,.6.7,1.5,1,2.6,1,1.1,0,1.9-.3,2.5-1,.9-1,.8-2.6.8-2.9.6,0,1.8,0,2.1.4.1.1,0,.6,0,1.2,0,1.2-.2,2.9.9,3.7,0,.7,0,5.7.8,7.2h0s0,0,0,0c.3,0,.5.3.6.7,0,.7-.6,1.7-1.8,2.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M29.1,32.8s.5,3.9-3.2,3.9c-3.8,0-3.4-3.9-3.4-3.9-.2,0-.5-.1-.7-.1.1,2.1.5,4.5,4.1,4.7,3.5.2,3.9-3,3.9-4.5-.4,0-.7,0-.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M29.9,32.8h0c-.4,0-.7,0-.7,0h0s0,0,0,0c0,0,.2,1.8-.7,2.9-.5.6-1.3.9-2.4.9-1,0-1.9-.3-2.4-.9-1-1.1-.9-2.9-.9-2.9h0c0,0,0,0,0,0-.2,0-.5-.1-.7-.1h0s0,0,0,0c.1,2.3.7,4.6,4.2,4.8.1,0,.2,0,.3,0,1,0,1.8-.3,2.4-.9,1.2-1.1,1.2-3,1.2-3.7h0ZM28.6,36.5c-.6.6-1.5.9-2.6.8-3.3-.2-3.9-2.3-4.1-4.5.2,0,.4,0,.6.1,0,.3,0,1.9.9,3,.6.7,1.5,1,2.6,1,1.1,0,1.9-.3,2.5-1,.9-1,.8-2.6.8-2.9.1,0,.3,0,.5,0,0,.8,0,2.5-1.2,3.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M31.4,33.3c0-.1-.2-.2-.4-.2-.2,1.1-.9,4.7,1.4,5.3h0s0,0,0-.1c-1.6-1.2-.5-4.4-.9-4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M32.4,38.1c-1.1-.7-.9-2.4-.8-3.6,0-.6,0-1.1,0-1.3,0-.1-.2-.2-.5-.3h0s0,0,0,0c-.3,1.1-.9,4.7,1.4,5.3h0s0-.2,0-.2h0ZM31,33.1c.2,0,.3.1.3.2.1.1,0,.6,0,1.2,0,1.2-.2,2.9.8,3.7-2-.7-1.4-3.9-1.2-5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M20.1,33.4c.8,4-1.2,6.2-1.2,6.2,2.8-1.3,2.1-5.1,1.6-6.7-.3.1-.5.3-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M20.6,32.8h0c-.3.2-.5.4-.5.6h0s0,0,0,0c.8,3.9-1.1,6.1-1.1,6.2l-.2.3h.3c2.9-1.4,2.1-5.3,1.7-6.9h0ZM19.2,39.4c.5-.7,1.6-2.8,1-6,0-.1.1-.2.4-.3.4,1.6,1,5-1.3,6.4Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M18.1,45.3h-.2c.2,1.3,1.5,1.5,1.5,1.5,0,0-1.2-.3-1.4-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M31.1,47.1s1.9-.2,2.1-1.8h-.2c-.1,1.4-1.9,1.8-1.9,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M33.1,45.3c-.7-1.4-.8-6-.8-7.2-1.6-1.2-.5-4.4-.9-4.9-.4-.5-2.2-.4-2.2-.4,0,0,.5,3.9-3.2,3.9,0,0,.1.6-.6.6,0,0,1.8,1.3,2.6,3,1.5,2.8,1.8,7.3-4.1,8.5,0,0,0,0,0,0,3.5.2,6.3-.1,8-.8,2-.7,2.3-2.7,1.2-3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M26.2,38.6c-.6,0-1.6-1.5-4.6-.7-1.4.5-1.4,1.4-1.4,1.4,0,0,2.5,5.4,6.2,2.7,2.4.4,6.7.3,6.7.3l.2-4.3s-2.7-1-7.2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M20.6,38.6s1-.1,1.5,0c-1.4.2-1.7.3-1.7.3l.2-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M33.2,42.3v-1.1c-4.7.5-6.3-.3-6.3-.3,0,0-.8,1.3-2.5,1.3-.4,0-.7-.1-1.7,0,1,.7,2.3,1,3.9-.1,2.4.4,6.7.3,6.7.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M26.2,38.6c-.1,0-.3-.1-.6-.2-.7-.4-1.8-1.1-4-.5-1.5.5-1.4,1.5-1.4,1.5h0c0,.1,1.3,2.9,3.4,3.4.2,0,.5,0,.7,0,.7,0,1.4-.2,2.1-.7,2.4.4,6.7.3,6.7.3v-.2s-4.4.1-6.7-.3h0s0,0,0,0c-.9.7-1.8.9-2.7.6-2-.5-3.2-3.1-3.3-3.3,0-.1,0-.9,1.3-1.3,2.1-.6,3.2,0,3.9.5.3.2.5.3.7.3h0c4.5-1.5,7.2-.7,7.2-.7,0,0-.4-.3-1.3-.4-1.2,0-3.3,0-5.9.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M26.4,42h.1c.5-.5.4-1,.4-1.1,0,0,0,.5-.5,1.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M18.1,40c.2.7,2.3,0,3.4-.3l.6-1s-4.1.7-4,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M18.2,39.9h0c.3.7,2.4,0,3.4-.3-.8-.3-2.6.4-3.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M22.1,38.6s-3.4.4-4,1.2c0,0,0,.1,0,.2,0,.1.1.2.2.3.1,0,.4.1.6.1.6,0,1.5-.2,2.3-.5h0c-1.4.3-2.4.4-2.7.2,0,0-.1-.1-.2-.2,0,0,0,0,0,0,.3-.5,2.9-1.1,3.9-1.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M17.6,41.1c.2.7,1.9.4,4.2-.4l-.3-1.1s-4.1.8-3.9,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M17.7,41.1s0,0,0,0c.2.7,1.9.3,4.1-.4-2-.6-3.3.6-4.1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M17.7,41.1s0,0,0-.1c.3-.5,2.8-1.2,3.8-1.4,0,0-3.5.6-3.9,1.3,0,0,0,.2,0,.2,0,.3.4.5,1,.5.7,0,1.8-.2,3.1-.6h0c-2.2.5-3.7.7-3.9,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M18.5,41.7c.2.9,4.4-.3,4.4-.3l-1.1-.7s-3.5.1-3.3,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M18.6,41.7s0,0-.1,0c0,0,0,0,0,0,.2.9,4.4-.3,4.4-.3-1.5-.4-3.5.5-4.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M18.8,41.9c0,0-.1-.1-.2-.2,0,0,0-.2,0-.2.4-.6,3.1-.8,3.1-.8,0,0-2.7,0-3.2.7,0,.1-.1.2,0,.4,0,.1.1.2.2.3.2.1.5.2.9.2,1.1,0,2.7-.4,2.8-.5h0c0-.1-2.8.6-3.5.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M20.4,42.1c.2.7,2.1.3,3.4.6l-1-1.3s-2.6.2-2.4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M23.4,42.1c-1.2,0-2.8,0-2.9,0,0,0,0,0,0,0,0,0,0,0,0,0,.2.7,2.1.3,3.4.6l-.4-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M20.5,42.1s0,0,0,0c.2-.3,1.5-.5,2.3-.6,0,0-2.2,0-2.5.5,0,0,0,.1,0,.2.1.5.9.5,1.7.5.6,0,1.2,0,1.7.1h0c-.5-.3-1.2-.3-1.7-.3-.8,0-1.5,0-1.6-.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M25.5,23.8c0,.1-.1.3-.4.5-.3.2-.5.2-.6,0s.1-.3.4-.5c.3-.2.5-.2.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M8.8,37.4h-.6s-.6,1-1.5,1.2c-.9.2-2.6.9-3,.7,0,0,0,0,0,0,0,0,0,0,0,0,.2.7,1.9,0,2.9-.2,1.1-.1,2.3-1.1,2.2-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M34.2,62.5c-1.2-3.1-5.5-10.4-5.2-11.8-2.9,1.7-6.6-.1-6.6-.1,0,0,.6,1.5-.5,3.2-1.1,1.6-3.7,8.6-3.7,8.6,0,0,0,0,0,0,.8.1,1.7.2,2.3,0,.3-.3,1.6-5.6,3.5-8.5.8-1.3.9-2,.9-2h1.9s2.1,3.9,3,5.6c.9,1.8,2,5.5,2,5.5,0,0,1,0,2.5-.3,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M31,16.9c-1.1,0-2,1.4-2,3.2,0,1.7,1,3.1,2.1,3.1,1.1,0,2-1.4,2-3.2,0-1.7-1-3.1-2.1-3.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M31,17.7c-1,0-1.8,1.2-1.8,2.7,0,1.5.9,2.7,1.9,2.7,1,0,1.8-1.2,1.8-2.7,0-1.5-.9-2.7-1.9-2.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31,18c-1,0-1.8,1.2-1.8,2.6,0,1.4.9,2.5,1.9,2.5,1,0,1.8-1.2,1.8-2.6,0-1.4-.9-2.5-1.9-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M31,18.3c-1,0-1.7,1.1-1.7,2.4,0,1.3.8,2.4,1.8,2.3,1,0,1.7-1.1,1.7-2.4,0-1.3-.8-2.4-1.8-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M31,18.3c-1,0-1.7,1.1-1.7,2.4,0,0,0,0,0,.1.2,1,.9,1.8,1.7,1.8,1,0,1.7-1.1,1.7-2.4,0,0,0,0,0-.1-.2-1-.9-1.8-1.7-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,18.3c-1,0-1.8,1.1-1.7,2.4,0,1.3.8,2.4,1.8,2.4,1,0,1.8-1.1,1.7-2.4,0-1.3-.8-2.4-1.8-2.4ZM31.1,23c-1,0-1.8-1-1.8-2.3,0-1.3.7-2.4,1.7-2.4,1,0,1.8,1,1.8,2.3,0,1.3-.7,2.4-1.7,2.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,19.3c-.7,0-1.3.8-1.3,1.8,0,1,.6,1.8,1.4,1.8.7,0,1.3-.8,1.3-1.8,0-1-.6-1.8-1.4-1.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-334"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 20.3,
    width: 3,
    height: 2.3,
    transform: "translate(3.9 47.6) rotate(-79.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,20.1c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,20.1c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,20.1c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,20.2c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,20.2c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,20.2c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3s1.1-.6,1.1-1.3c0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,20.2c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,20.2c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,20.2c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,20.2c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,20.2c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,20.2c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,20.2c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,20.2c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.2.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,20.2c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.2.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,20.2c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.2.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,20.2c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.2.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,20.2c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.2.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,20.2c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,20.2c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1.1-.6,1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M30.7,20.2c-.6,0-1.1.6-1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1.1-.6,1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M30.7,20.2c-.6,0-1.1.6-1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1.1-.6,1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M30.7,20.2c-.6,0-1.1.6-1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1.1-.6,1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M30.7,20.2c-.6,0-1.1.6-1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1.1-.6,1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M30.7,20.2c-.6,0-1.1.6-1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1.1-.6,1-1.3s-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M30.7,20.2c-.6,0-1.1.6-1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1.1-.6,1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M30.7,20.2c-.6,0-1,.6-1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M30.7,20.2c-.6,0-1,.6-1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M30.7,20.2c-.6,0-1,.6-1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M30.7,20.2c-.6,0-1,.6-1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M30.7,20.2c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M30.7,20.2c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M30.7,20.2c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M30.7,20.2c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M30.7,20.2c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M30.7,20.2c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M30.7,20.2c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M30.7,20.2c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M30.7,20.2c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M30.7,20.2c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M30.7,20.3c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M30.7,20.3c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M30.7,20.3c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M30.7,20.3c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M30.7,20.3c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M30.7,20.3c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M30.7,20.3c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M30.7,20.3c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M30.7,20.3c-.6,0-1,.5-1,1.2,0,.7.5,1.2,1,1.2.6,0,1-.5,1-1.2,0-.7-.5-1.2-1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M30.7,20.3c-.6,0-1,.5-1,1.2,0,.6.5,1.2,1,1.2.6,0,1-.5,1-1.2,0-.6-.5-1.2-1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M30.7,20.3c-.6,0-1,.5-1,1.2,0,.6.5,1.2,1,1.2.6,0,1-.5,1-1.2,0-.6-.5-1.2-1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M30.7,20.3c-.6,0-1,.5-1,1.2,0,.6.5,1.2,1,1.1.6,0,1-.5,1-1.2,0-.6-.5-1.2-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M30.7,20.3c-.6,0-1,.5-1,1.2,0,.6.5,1.2,1,1.1.6,0,1-.5,1-1.2,0-.6-.5-1.2-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M30.7,20.3c-.6,0-1,.5-1,1.2,0,.6.5,1.2,1,1.1.6,0,1-.5,1-1.2,0-.6-.5-1.2-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M30.7,20.3c-.6,0-1,.5-1,1.2,0,.6.5,1.2,1,1.1.6,0,1-.5,1-1.2,0-.6-.5-1.2-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M30.7,20.3c-.5,0-1,.5-1,1.2,0,.6.5,1.2,1,1.1.5,0,1-.5,1-1.2,0-.6-.5-1.2-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M30.7,20.3c-.5,0-1,.5-1,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5,1-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M30.7,20.3c-.5,0-1,.5-1,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5,1-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M30.7,20.3c-.5,0-1,.5-1,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5,1-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M30.7,20.3c-.5,0-1,.5-1,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5,1-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M30.7,20.3c-.5,0-1,.5-1,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5,1-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M30.7,20.3c-.5,0-1,.5-1,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5,1-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M30.7,20.3c-.5,0-1,.5-1,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5,1-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M30.7,20.3c-.5,0-1,.5-1,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5,1-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M30.7,20.3c-.5,0-1,.5-1,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5,1-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M30.7,20.3c-.5,0-1,.5-.9,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5.9-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M30.7,20.3c-.5,0-1,.5-.9,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5.9-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M30.7,20.3c-.5,0-1,.5-.9,1.1,0,.6.5,1.1,1,1.1.5,0,1-.5.9-1.1,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-353",
    d: "M30.7,20.3c-.5,0-1,.5-.9,1.1,0,.6.5,1.1,1,1.1.5,0,1-.5.9-1.1,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-353",
    d: "M30.7,20.3c-.5,0-1,.5-.9,1.1,0,.6.5,1.1,1,1.1.5,0,1-.5.9-1.1,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M30.7,20.3c-.5,0-1,.5-.9,1.1,0,.6.5,1.1,1,1.1.5,0,1-.5.9-1.1,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M30.7,20.3c-.5,0-.9.5-.9,1.1,0,.6.5,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M30.7,20.3c-.5,0-.9.5-.9,1.1,0,.6.5,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M30.7,20.3c-.5,0-.9.5-.9,1.1,0,.6.5,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.7,20.3c-.5,0-.9.5-.9,1.1,0,.6.5,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.7,20.3c-.5,0-.9.5-.9,1.1,0,.6.4,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.7,20.3c-.5,0-.9.5-.9,1.1,0,.6.4,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.7,20.3c-.5,0-.9.5-.9,1.1,0,.6.4,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1.1,1,1.1.5,0,.9-.5.9-1.1s-.4-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1.1.9,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-.9-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1.1.9,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-.9-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-346",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1.1.9,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-.9-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-346",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1.1.9,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-.9-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1.1.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1.1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-330",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1.1.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1.1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1.1.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1.1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1.1.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1.1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-345",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1s.4,1,.9,1c.5,0,.9-.5.9-1.1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1.1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M30.7,20.4c-.5,0-.9.5-.9,1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M30.7,20.4c-.5,0-.9.5-.8,1,0,.6.4,1,.9,1,.5,0,.9-.5.8-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M30.7,20.4c-.5,0-.9.5-.8,1,0,.6.4,1,.9,1,.5,0,.9-.5.8-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M30.7,20.4c-.5,0-.9.5-.8,1,0,.6.4,1,.9,1,.5,0,.9-.5.8-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M30.7,20.4c-.5,0-.9.5-.8,1,0,.6.4,1,.9,1,.5,0,.9-.5.8-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M30.7,20.4c-.5,0-.9.5-.8,1,0,.6.4,1,.9,1s.9-.5.8-1c0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M30.7,20.4c-.5,0-.8.5-.8,1,0,.6.4,1,.9,1,.5,0,.8-.5.8-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M30.7,20.5c-.5,0-.8.5-.8,1,0,.6.4,1,.9,1,.5,0,.8-.5.8-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M30.7,20.5c-.5,0-.8.5-.8,1,0,.6.4,1,.9,1,.5,0,.8-.5.8-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M30.7,20.5c-.5,0-.8.5-.8,1,0,.5.4,1,.9,1,.5,0,.8-.5.8-1,0-.5-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30.7,20.5c-.5,0-.8.5-.8,1,0,.5.4,1,.9,1,.5,0,.8-.5.8-1,0-.5-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M30.7,20.5c-.5,0-.8.5-.8,1,0,.5.4,1,.9,1,.5,0,.8-.5.8-1,0-.5-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "M30.7,20.5c-.5,0-.8.5-.8,1,0,.5.4,1,.9,1,.5,0,.8-.5.8-1,0-.5-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M30.7,20.5c-.5,0-.8.5-.8,1,0,.5.4,1,.9,1,.5,0,.8-.5.8-1,0-.5-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M30.7,20.5c-.5,0-.8.5-.8,1,0,.5.4,1,.9,1,.5,0,.8-.5.8-1,0-.5-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M30.7,20.5c-.5,0-.8.5-.8,1,0,.5.4,1,.9,1,.5,0,.8-.5.8-1,0-.5-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-331",
    d: "M30.7,20.5c-.5,0-.8.5-.8,1,0,.5.4,1,.9,1,.5,0,.8-.5.8-1,0-.5-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M30.7,20.5c-.5,0-.8.5-.8,1,0,.5.4,1,.9,1,.5,0,.8-.5.8-1,0-.5-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M30.7,20.5c-.5,0-.8.5-.8,1,0,.5.4,1,.9,1,.5,0,.8-.5.8-1s-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M30.7,20.5c-.5,0-.8.5-.8,1,0,.5.4,1,.9.9.5,0,.8-.5.8-1,0-.5-.4-1-.9-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "M30.7,20.5c-.5,0-.8.4-.8,1,0,.5.4,1,.8.9.5,0,.8-.4.8-1,0-.5-.4-1-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-322",
    d: "M30.7,20.5c-.5,0-.8.4-.8,1,0,.5.4,1,.8.9s.8-.4.8-1c0-.5-.4-1-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M30.7,20.5c-.5,0-.8.4-.8,1,0,.5.4,1,.8.9.5,0,.8-.4.8-1,0-.5-.4-1-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-311",
    d: "M30.7,20.5c-.5,0-.8.4-.8,1,0,.5.4.9.8.9.5,0,.8-.4.8-1,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M30.7,20.5c-.5,0-.8.4-.8,1,0,.5.4.9.8.9.5,0,.8-.4.8-1,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M30.7,20.5c-.5,0-.8.4-.8,1,0,.5.4.9.8.9.5,0,.8-.4.8-1,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-313",
    d: "M30.7,20.5c-.4,0-.8.4-.8,1,0,.5.4.9.8.9.4,0,.8-.4.8-1,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M30.7,20.5c-.4,0-.8.4-.8,1,0,.5.4.9.8.9.4,0,.8-.4.8-1,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M30.7,20.5c-.4,0-.8.4-.8,1,0,.5.4.9.8.9.4,0,.8-.4.8-1,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M30.7,20.5c-.4,0-.8.4-.8,1,0,.5.4.9.8.9.4,0,.8-.4.8-1,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M30.7,20.5c-.4,0-.8.4-.8,1,0,.5.4.9.8.9.4,0,.8-.4.8-1,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-337",
    d: "M30.7,20.5c-.4,0-.8.4-.8,1,0,.5.4.9.8.9.4,0,.8-.4.8-1,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M30.7,20.5c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M30.7,20.5c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M30.7,20.5c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "M30.7,20.5c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M30.7,20.5c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M30.7,20.5c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M30.7,20.5c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M30.7,20.5c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M30.7,20.5c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M30.7,20.5c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M30.7,20.5c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M30.7,20.5c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M30.7,20.5c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M30.7,20.6c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M30.7,20.6c-.4,0-.8.4-.7.9,0,.5.4.9.8.9.4,0,.8-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M30.7,20.6c-.4,0-.8.4-.7.9,0,.5.4.9.8.9.4,0,.8-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-329",
    d: "M30.7,20.6c-.4,0-.8.4-.7.9,0,.5.4.9.8.9.4,0,.8-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M30.7,20.6c-.4,0-.8.4-.7.9,0,.5.4.9.8.9.4,0,.8-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M30.7,20.6c-.4,0-.8.4-.7.9,0,.5.4.9.8.9.4,0,.8-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M30.7,20.6c-.4,0-.7.4-.7.9,0,.5.4.9.8.9.4,0,.7-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M30.7,20.6c-.4,0-.7.4-.7.9,0,.5.4.9.8.9.4,0,.7-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M30.7,20.6c-.4,0-.7.4-.7.9,0,.5.4.9.8.9.4,0,.7-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M30.7,20.6c-.4,0-.7.4-.7.9,0,.5.4.9.8.9.4,0,.7-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M30.7,20.6c-.4,0-.7.4-.7.9,0,.5.4.9.8.9.4,0,.7-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M30.7,20.6c-.4,0-.7.4-.7.9,0,.5.4.9.8.9.4,0,.7-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M30.7,20.6c-.4,0-.7.4-.7.9,0,.5.4.9.8.9.4,0,.7-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M30.7,20.6c-.4,0-.7.4-.7.9,0,.5.4.9.8.8.4,0,.7-.4.7-.9,0-.5-.4-.9-.8-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M30.7,20.6c-.4,0-.7.4-.7.9,0,.5.3.9.8.8.4,0,.7-.4.7-.9,0-.5-.3-.9-.8-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M30.7,20.6c-.4,0-.7.4-.7.9,0,.5.3.9.8.8.4,0,.7-.4.7-.9,0-.5-.3-.9-.8-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M30.7,20.6c-.4,0-.7.4-.7.9,0,.5.3.8.8.8.4,0,.7-.4.7-.9,0-.5-.3-.8-.8-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M30.7,20.6c-.4,0-.7.4-.7.9,0,.5.3.8.8.8.4,0,.7-.4.7-.9,0-.5-.3-.8-.8-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M30.7,20.6c-.4,0-.7.4-.7.9,0,.5.3.8.7.8.4,0,.7-.4.7-.9,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M30.7,20.6c-.4,0-.7.4-.7.9,0,.5.3.8.7.8.4,0,.7-.4.7-.9,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M30.7,20.6c-.4,0-.7.4-.7.9,0,.5.3.8.7.8.4,0,.7-.4.7-.9,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M30.7,20.6c-.4,0-.7.4-.7.9,0,.5.3.8.7.8.4,0,.7-.4.7-.9,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M30.7,20.6c-.4,0-.7.4-.7.9,0,.5.3.8.7.8.4,0,.7-.4.7-.9,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M30.7,20.6c-.4,0-.7.4-.7.9,0,.5.3.8.7.8.4,0,.7-.4.7-.9,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M30.7,20.6c-.4,0-.7.4-.7.9,0,.5.3.8.7.8.4,0,.7-.4.7-.9,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M30.7,20.6c-.4,0-.7.4-.7.8,0,.5.3.8.7.8.4,0,.7-.4.7-.8,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M30.7,20.6c-.4,0-.7.4-.7.8,0,.5.3.8.7.8.4,0,.7-.4.7-.8,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-327",
    d: "M30.7,20.6c-.4,0-.7.4-.7.8,0,.5.3.8.7.8.4,0,.7-.4.7-.8,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M30.7,20.6c-.4,0-.7.4-.7.8,0,.5.3.8.7.8.4,0,.7-.4.7-.8,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M30.7,20.6c-.4,0-.7.4-.7.8,0,.5.3.8.7.8.4,0,.7-.4.7-.8,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M30.7,20.6c-.4,0-.7.4-.7.8,0,.5.3.8.7.8.4,0,.7-.4.7-.8,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M30.7,20.6c-.4,0-.7.4-.7.8,0,.5.3.8.7.8.4,0,.7-.4.7-.8,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M30.7,20.6c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M30.7,20.6c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M30.7,20.6c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M30.7,20.6c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M30.7,20.6c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M30.7,20.7c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M30.7,20.7c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M30.7,20.7c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M30.7,20.7c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-328",
    d: "M30.7,20.7c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M30.7,20.7c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M30.7,20.7c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M30.7,20.7c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M30.7,20.7c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M30.7,20.7c-.4,0-.6.4-.6.8,0,.4.3.8.7.8.4,0,.6-.4.6-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M30.7,20.7c-.4,0-.6.4-.6.8,0,.4.3.7.7.7.4,0,.6-.4.6-.8,0-.4-.3-.7-.7-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M30.7,20.7c-.3,0-.6.3-.6.8,0,.4.3.7.6.7.3,0,.6-.3.6-.8,0-.4-.3-.7-.6-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-355",
    d: "M30.7,20.7c-.3,0-.6.3-.6.7,0,.4.3.7.6.7.3,0,.6-.3.6-.7,0-.4-.3-.7-.6-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M30.7,20.7c-.3,0-.6.3-.6.7,0,.4.3.7.6.7.3,0,.6-.3.6-.7,0-.4-.3-.7-.6-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M30.7,20.8c-.3,0-.6.3-.6.7,0,.4.3.7.6.7.3,0,.6-.3.6-.7,0-.4-.3-.7-.6-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.7,20.8c-.3,0-.6.3-.6.7,0,.4.3.7.6.7.3,0,.6-.3.6-.7,0-.4-.3-.7-.6-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M30.7,20.8c-.3,0-.6.3-.6.7,0,.4.3.7.6.7.3,0,.6-.3.6-.7,0-.4-.3-.7-.6-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M30.7,20.8c-.3,0-.6.3-.5.7,0,.4.3.6.6.6.3,0,.6-.3.5-.7,0-.4-.3-.6-.6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M30.7,20.8c-.3,0-.5.3-.5.7,0,.4.3.6.6.6.3,0,.5-.3.5-.7,0-.4-.3-.6-.6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-318",
    d: "M30.7,20.8c-.3,0-.5.3-.5.6,0,.3.3.6.6.6.3,0,.5-.3.5-.6,0-.3-.3-.6-.6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M30.7,20.8c-.3,0-.5.3-.5.6,0,.3.2.6.5.6.3,0,.5-.3.5-.6,0-.3-.2-.6-.5-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M30.7,20.9c-.3,0-.5.3-.5.6,0,.3.2.6.5.6.3,0,.5-.3.5-.6,0-.3-.2-.6-.5-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M30.7,20.9c-.3,0-.5.3-.5.6,0,.3.2.6.5.6.3,0,.5-.3.5-.6,0-.3-.2-.6-.5-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-343",
    d: "M30.7,20.9c-.3,0-.5.3-.5.6,0,.3.2.6.5.6.3,0,.5-.3.5-.6,0-.3-.2-.6-.5-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M30.7,20.9c-.3,0-.5.3-.5.6,0,.3.2.6.5.5.3,0,.5-.3.5-.6,0-.3-.2-.6-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M30.7,20.9c-.3,0-.5.3-.5.6,0,.3.2.5.5.5.3,0,.5-.3.5-.6,0-.3-.2-.5-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M30.7,20.9c-.3,0-.4.2-.4.5,0,.3.2.5.5.5.3,0,.4-.2.4-.5,0-.3-.2-.5-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "M30.7,20.9c-.2,0-.4.2-.4.5,0,.3.2.5.5.5.2,0,.4-.2.4-.5,0-.3-.2-.5-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M30.7,20.9c-.2,0-.4.2-.4.5,0,.3.2.5.4.5.2,0,.4-.2.4-.5,0-.3-.2-.5-.4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-351",
    d: "M30.7,21c-.2,0-.4.2-.4.5,0,.3.2.5.4.5.2,0,.4-.2.4-.5,0-.3-.2-.5-.4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M30.7,21c-.2,0-.4.2-.4.5,0,.3.2.5.4.5.2,0,.4-.2.4-.5,0-.3-.2-.5-.4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-342",
    d: "M30.7,21c-.2,0-.4.2-.4.5,0,.3.2.5.4.5.2,0,.4-.2.4-.5,0-.3-.2-.5-.4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M30.7,21c-.2,0-.4.2-.4.5,0,.2.2.4.4.4.2,0,.4-.2.4-.5,0-.2-.2-.4-.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M30.7,21c-.2,0-.4.2-.4.4,0,.2.2.4.4.4.2,0,.4-.2.4-.4,0-.2-.2-.4-.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M30.7,21c-.2,0-.4.2-.3.4,0,.2.2.4.4.4.2,0,.4-.2.3-.4,0-.2-.2-.4-.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M30.7,21c-.2,0-.3.2-.3.4,0,.2.2.4.4.4.2,0,.3-.2.3-.4,0-.2-.2-.4-.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M30.7,21.1c-.2,0-.3.2-.3.4,0,.2.2.4.3.4.2,0,.3-.2.3-.4s-.2-.4-.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M30.7,21.1c-.2,0-.3.2-.3.4,0,.2.2.4.3.4.2,0,.3-.2.3-.4,0-.2-.2-.4-.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M30.7,21.1c-.2,0-.3.2-.3.4,0,.2.1.4.3.4.2,0,.3-.2.3-.4,0-.2-.1-.4-.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M30.7,21.1c-.2,0-.3.2-.3.4,0,.2.1.3.3.3.2,0,.3-.2.3-.4,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M30.7,21.1c-.2,0-.3.2-.3.3,0,.2.1.3.3.3.2,0,.3-.2.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M30.7,21.1c-.2,0-.3.1-.3.3,0,.2.1.3.3.3.2,0,.3-.1.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M30.7,21.1c-.1,0-.3.1-.3.3,0,.2.1.3.3.3.1,0,.3-.1.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M30.7,21.2c-.1,0-.2.1-.2.3,0,.2.1.3.3.3.1,0,.2-.1.2-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M30.7,21.2c-.1,0-.2.1-.2.3s.1.3.2.3c.1,0,.2-.1.2-.3,0-.2-.1-.3-.2-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M30.7,21.2c-.1,0-.2.1-.2.3,0,.1.1.3.2.3.1,0,.2-.1.2-.3,0-.1-.1-.3-.2-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M30.7,21.2c-.1,0-.2.1-.2.3,0,.1.1.2.2.2.1,0,.2-.1.2-.3,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M30.7,21.2c-.1,0-.2.1-.2.2,0,.1,0,.2.2.2.1,0,.2-.1.2-.2,0-.1,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M30.7,21.2c-.1,0-.2.1-.2.2s0,.2.2.2c.1,0,.2-.1.2-.2s0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M30.7,21.2c0,0-.2,0-.2.2,0,.1,0,.2.2.2,0,0,.2,0,.2-.2,0-.1,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M30.7,21.3c0,0-.2,0-.2.2,0,.1,0,.2.2.2,0,0,.2,0,.2-.2,0-.1,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M30.7,21.3c0,0-.2,0-.2.2,0,0,0,.2.2.2,0,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M30.7,21.3c0,0-.1,0-.1.2,0,0,0,.2.1.2,0,0,.1,0,.1-.2,0,0,0-.2-.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M30.7,21.3c0,0-.1,0-.1.2,0,0,0,.2.1.2,0,0,.1,0,.1-.2,0,0,0-.2-.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M30.7,21.3c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M30.7,21.3c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M30.7,21.3c0,0,0,0,0,.1,0,0,0,.1,0,.1,0,0,0,0,0-.1,0,0,0-.1,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M30.7,21.4s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M30.7,21.4s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M30.7,21.4s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M30.7,21.4s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M30.7,21.4s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M30.7,21.4s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M30.7,21.4s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,20.3c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-170"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 21.6,
    width: 0.7,
    height: 0.8,
    transform: "translate(3 47.7) rotate(-79.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4,21.7c-.2,0-.4.2-.4.3,0,.2.2.3.4.3.2,0,.4-.2.4-.3,0-.2-.2-.3-.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4,21.7c-.2,0-.4.2-.3.3,0,.2.2.3.4.3.2,0,.4-.2.3-.3,0-.2-.2-.3-.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M30.4,21.7c-.2,0-.4.2-.3.3,0,.2.2.3.4.3.2,0,.4-.2.3-.3,0-.2-.2-.3-.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M30.4,21.7c-.2,0-.3.2-.3.3,0,.2.2.3.4.3.2,0,.3-.2.3-.3,0-.2-.2-.3-.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M30.4,21.7c-.2,0-.3.1-.3.3,0,.2.2.3.4.3.2,0,.3-.2.3-.3,0-.2-.2-.3-.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M30.4,21.7c-.2,0-.3.1-.3.3,0,.2.2.3.4.3.2,0,.3-.1.3-.3,0-.2-.2-.3-.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M30.4,21.7c-.2,0-.3.1-.3.3,0,.2.2.3.3.3.2,0,.3-.1.3-.3,0-.2-.2-.3-.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M30.4,21.7c-.2,0-.3.1-.3.3,0,.2.2.3.3.3.2,0,.3-.1.3-.3,0-.2-.2-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M30.4,21.7c-.2,0-.3.1-.3.3,0,.2.2.3.3.3.2,0,.3-.1.3-.3,0-.2-.2-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M30.4,21.7c-.2,0-.3.1-.3.3,0,.2.2.3.3.3.2,0,.3-.1.3-.3,0-.2-.2-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M30.4,21.7c-.2,0-.3.1-.3.3,0,.2.2.3.3.3.2,0,.3-.1.3-.3,0-.2-.2-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-315",
    d: "M30.4,21.7c-.2,0-.3.1-.3.3,0,.2.2.3.3.3.2,0,.3-.1.3-.3,0-.2-.2-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M30.4,21.7c-.2,0-.3.1-.3.3,0,.2.2.3.3.3.2,0,.3-.1.3-.3,0-.2-.2-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M30.4,21.7c-.2,0-.3.1-.3.3,0,.2.2.3.3.3.2,0,.3-.1.3-.3,0-.2-.2-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M30.4,21.7c-.2,0-.3.1-.3.3,0,.2.2.3.3.3.2,0,.3-.1.3-.3,0-.2-.2-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M30.4,21.7c-.2,0-.3.1-.3.3,0,.2.1.3.3.3.2,0,.3-.1.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M30.4,21.7c-.2,0-.3.1-.3.3,0,.2.1.3.3.3.2,0,.3-.1.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M30.4,21.7c-.2,0-.3.1-.3.3,0,.2.1.3.3.3.2,0,.3-.1.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M30.4,21.8c-.2,0-.3.1-.3.3,0,.2.1.3.3.3.2,0,.3-.1.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M30.4,21.8c-.2,0-.3.1-.3.3,0,.2.1.3.3.3.2,0,.3-.1.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M30.4,21.8c-.2,0-.3.1-.3.3,0,.2.1.3.3.3.2,0,.3-.1.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M30.4,21.8c-.2,0-.3.1-.3.3,0,.2.1.3.3.3.2,0,.3-.1.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M30.4,21.8c-.2,0-.3.1-.3.3,0,.2.1.3.3.3.2,0,.3-.1.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M30.4,21.8c-.2,0-.3.1-.3.3,0,.2.1.3.3.3.2,0,.3-.1.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M30.4,21.8c-.2,0-.3.1-.3.3,0,.1.1.3.3.3.2,0,.3-.1.3-.3,0-.1-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M30.4,21.8c-.2,0-.3.1-.3.3,0,.1.1.3.3.3.2,0,.3-.1.3-.3,0-.1-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M30.4,21.8c-.2,0-.3.1-.3.3,0,.1.1.3.3.3.2,0,.3-.1.3-.3,0-.1-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M30.4,21.8c-.2,0-.3.1-.3.3,0,.1.1.3.3.3.2,0,.3-.1.3-.3,0-.1-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M30.4,21.8c-.2,0-.3.1-.3.3,0,.1.1.3.3.3.2,0,.3-.1.3-.3,0-.1-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-349",
    d: "M30.4,21.8c-.2,0-.3.1-.3.3,0,.1.1.3.3.3.2,0,.3-.1.3-.3,0-.1-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M30.4,21.8c-.2,0-.3.1-.3.3,0,.1.1.3.3.3.2,0,.3-.1.3-.3,0-.1-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M30.4,21.8c-.2,0-.3.1-.3.3,0,.1.1.3.3.2.2,0,.3-.1.3-.3,0-.1-.1-.3-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "M30.4,21.8c-.2,0-.3.1-.3.3,0,.1.1.2.3.2.2,0,.3-.1.3-.3,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-319",
    d: "M30.4,21.8c-.2,0-.3.1-.3.3,0,.1.1.2.3.2.2,0,.3-.1.3-.3,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M30.4,21.8c-.1,0-.3.1-.3.3,0,.1.1.2.3.2.1,0,.3-.1.3-.3,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M30.4,21.8c-.1,0-.3.1-.3.2,0,.1.1.2.3.2.1,0,.3-.1.3-.2,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M30.4,21.8c-.1,0-.3.1-.3.2,0,.1.1.2.3.2.1,0,.3-.1.3-.2,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M30.4,21.8c-.1,0-.3.1-.3.2,0,.1.1.2.3.2.1,0,.3-.1.3-.2,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M30.4,21.8c-.1,0-.3.1-.3.2,0,.1.1.2.3.2.1,0,.3-.1.3-.2,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M30.4,21.8c-.1,0-.3.1-.3.2,0,.1.1.2.3.2.1,0,.3-.1.3-.2,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M30.4,21.8c-.1,0-.3.1-.2.2,0,.1.1.2.3.2.1,0,.3-.1.2-.2,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M30.4,21.8c-.1,0-.2.1-.2.2,0,.1.1.2.3.2.1,0,.2-.1.2-.2,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-350",
    d: "M30.4,21.8c-.1,0-.2.1-.2.2,0,.1.1.2.3.2.1,0,.2-.1.2-.2,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M30.4,21.8c-.1,0-.2.1-.2.2,0,.1.1.2.3.2.1,0,.2-.1.2-.2,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M30.4,21.8c-.1,0-.2.1-.2.2,0,.1.1.2.2.2.1,0,.2-.1.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M30.4,21.8c-.1,0-.2.1-.2.2,0,.1.1.2.2.2.1,0,.2-.1.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M29.9,21.4c-.1,0-.2.1-.2.2,0,.1.1.2.2.2.1,0,.2-.1.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M29.9,21.4c-.1,0-.2.1-.2.2,0,.1.1.2.2.2.1,0,.2-.1.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M29.9,21.4c-.1,0-.2.1-.2.2,0,.1.1.2.2.2.1,0,.2-.1.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M29.9,21.4c-.1,0-.2,0-.2.2,0,.1.1.2.2.2.1,0,.2,0,.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M29.9,21.4c-.1,0-.2,0-.2.2,0,.1.1.2.2.2.1,0,.2,0,.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M29.9,21.4c-.1,0-.2,0-.2.2,0,.1.1.2.2.2.1,0,.2,0,.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M29.9,21.4c-.1,0-.2,0-.2.2,0,.1.1.2.2.2.1,0,.2,0,.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M29.9,21.4c-.1,0-.2,0-.2.2,0,.1.1.2.2.2.1,0,.2,0,.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M29.9,21.4c-.1,0-.2,0-.2.2,0,.1.1.2.2.2.1,0,.2,0,.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M29.9,21.4c-.1,0-.2,0-.2.2,0,.1.1.2.2.2.1,0,.2,0,.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M29.9,21.4c-.1,0-.2,0-.2.2,0,.1,0,.2.2.2.1,0,.2,0,.2-.2,0-.1,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-312",
    d: "M29.9,21.4c-.1,0-.2,0-.2.2,0,.1,0,.2.2.2.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M29.9,21.4c-.1,0-.2,0-.2.2,0,.1,0,.2.2.2.1,0,.2,0,.2-.2,0-.1,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "M29.9,21.4c-.1,0-.2,0-.2.2,0,.1,0,.2.2.2.1,0,.2,0,.2-.2,0-.1,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M29.9,21.4c-.1,0-.2,0-.2.2,0,.1,0,.2.2.2.1,0,.2,0,.2-.2,0-.1,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M29.9,21.4c-.1,0-.2,0-.2.2,0,.1,0,.2.2.2.1,0,.2,0,.2-.2,0-.1,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M29.9,21.5c-.1,0-.2,0-.2.2,0,0,0,.2.2.2.1,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M29.9,21.5c-.1,0-.2,0-.2.2,0,0,0,.2.2.2.1,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-354",
    d: "M29.9,21.5c-.1,0-.2,0-.2.2,0,0,0,.2.2.2.1,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M29.9,21.5c-.1,0-.2,0-.2.2,0,0,0,.2.2.2.1,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M29.9,21.5c-.1,0-.2,0-.2.2,0,0,0,.2.2.2.1,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M29.9,21.5c-.1,0-.2,0-.2.2,0,0,0,.2.2.2.1,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M29.9,21.5c0,0-.2,0-.2.2,0,0,0,.2.2.2,0,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M29.9,21.5c0,0-.2,0-.2.2,0,0,0,.2.2.2,0,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M29.9,21.5c0,0-.2,0-.2.2,0,0,0,.2.2.2,0,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M29.9,21.5c0,0-.2,0-.2.2,0,0,0,.2.2.2,0,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-352",
    d: "M29.9,21.5c0,0-.2,0-.2.2,0,0,0,.2.2.2,0,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M29.9,21.5c0,0-.2,0-.2.2,0,0,0,.2.2.1,0,0,.2,0,.2-.2,0,0,0-.2-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M29.9,21.5c0,0-.2,0-.2.2,0,0,0,.1.2.1,0,0,.2,0,.2-.2,0,0,0-.1-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M29.9,21.5c0,0-.2,0-.2.2,0,0,0,.1.2.1,0,0,.2,0,.2-.2,0,0,0-.1-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M29.9,21.5c0,0-.2,0-.2.1,0,0,0,.1.2.1,0,0,.2,0,.2-.1,0,0,0-.1-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M29.9,21.5c0,0-.2,0-.2.1,0,0,0,.1.2.1,0,0,.2,0,.2-.1,0,0,0-.1-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M29.9,21.5c0,0-.2,0-.2.1,0,0,0,.1.2.1,0,0,.2,0,.2-.1,0,0,0-.1-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M29.9,21.5c0,0-.2,0-.1.1,0,0,0,.1.2.1,0,0,.2,0,.1-.1,0,0,0-.1-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M29.9,21.5c0,0-.1,0-.1.1,0,0,0,.1.2.1,0,0,.1,0,.1-.1,0,0,0-.1-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M29.9,21.5c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M29.9,21.5c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M29.9,21.5c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-333",
    d: "M29.9,21.5c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M29.9,21.5c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M29.9,21.5c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M29.9,21.5c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-356",
    d: "M29.9,21.5c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M29.9,21.5c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M29.9,21.5c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M29.9,21.5c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M29.9,21.5c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M29.9,21.5c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M29.9,21.5c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M29.9,21.5c0,0-.1,0-.1.1,0,0,0,0,.1,0,0,0,.1,0,.1-.1,0,0,0,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M29.9,21.5c0,0-.1,0-.1.1,0,0,0,0,.1,0,0,0,.1,0,.1-.1,0,0,0,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M29.9,21.5c0,0-.1,0-.1,0,0,0,0,0,.1,0,0,0,.1,0,.1,0,0,0,0,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M29.9,21.5c0,0-.1,0-.1,0,0,0,0,0,.1,0,0,0,.1,0,.1,0,0,0,0,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M29.9,21.5c0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,0,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-323",
    d: "M29.9,21.5c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M29.9,21.5c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M29.9,21.5c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-339",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-340",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M29.9,21.6s0,0,0,0,0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M29.9,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "29.9 21.6 29.9 21.6 29.9 21.6 29.9 21.6 29.9 21.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "29.9 21.6 29.9 21.6 29.9 21.6 29.9 21.6 29.9 21.6"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M31.1,18.4c-.5,0-.8.4-.8.9,0,.5.4.8.9.8.5,0,.8-.4.8-.9,0-.5-.4-.8-.9-.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M30.8,20.7c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M33.1,23.2c0,.4-.8.7-1.8.7s-1.8-.3-1.8-.7.8-.7,1.8-.7,1.8.3,1.8.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M19.1,17.2c-1.2,0-2.1,1.4-2,3.2,0,1.7,1,3.1,2.2,3.1,1.2,0,2.1-1.4,2-3.2,0-1.7-1-3.1-2.2-3.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M19.1,18c-1,0-1.8,1.2-1.8,2.7,0,1.5.9,2.7,1.9,2.7,1,0,1.8-1.2,1.8-2.7,0-1.5-.9-2.7-1.9-2.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.1,18.3c-1,0-1.8,1.2-1.8,2.6,0,1.4.9,2.5,1.9,2.5,1,0,1.8-1.2,1.8-2.6s-.9-2.5-1.9-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M19.1,18.6c-1,0-1.7,1.1-1.7,2.4,0,1.3.8,2.4,1.8,2.4,1,0,1.7-1.1,1.7-2.4,0-1.3-.8-2.4-1.8-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M19.1,18.6c-.8,0-1.5.8-1.7,1.8,0,0,0,0,0,.1,0,1.3.8,2.4,1.8,2.4.8,0,1.5-.8,1.7-1.8,0,0,0,0,0-.1,0-1.3-.8-2.4-1.8-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1,18.5c-1,0-1.8,1.1-1.7,2.4,0,1.3.9,2.4,1.8,2.4,1,0,1.8-1.1,1.7-2.4,0-1.3-.9-2.4-1.8-2.4ZM19.2,23.3c-1,0-1.8-1-1.8-2.3,0-1.3.7-2.4,1.7-2.4,1,0,1.8,1,1.8,2.3,0,1.3-.7,2.4-1.7,2.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,19.6c-.7,0-1.3.8-1.3,1.8,0,1,.6,1.8,1.4,1.8.7,0,1.3-.8,1.3-1.8,0-1-.6-1.8-1.4-1.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-295"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20.6,
    width: 3,
    height: 2.3,
    transform: "translate(-5.5 36.8) rotate(-79.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,20.4c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.2,1.3.6,0,1.1-.6,1.1-1.3s-.5-1.3-1.2-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,20.4c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.2-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,20.4c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,20.4c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,20.4c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,20.4c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,20.4c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,20.4c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,20.4c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,20.4c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,20.4c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,20.4c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,20.4c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,20.4c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.3.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,20.5c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.2.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,20.5c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.2.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,20.5c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.2.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,20.5c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.2.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,20.5c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.3,1.1,1.2.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.3-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,20.5c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M19.5,20.5c-.6,0-1.1.6-1.1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1.1-.6,1.1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M19.5,20.5c-.6,0-1.1.6-1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1.1-.6,1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M19.5,20.5c-.6,0-1.1.6-1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1.1-.6,1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M19.5,20.5c-.6,0-1.1.6-1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1.1-.6,1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M19.5,20.5c-.6,0-1.1.6-1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1.1-.6,1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M19.5,20.5c-.6,0-1.1.6-1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1.1-.6,1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M19.5,20.5c-.6,0-1.1.6-1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1.1-.6,1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M19.5,20.5c-.6,0-1.1.6-1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1.1-.6,1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M19.5,20.5c-.6,0-1,.6-1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.3s-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M19.5,20.5c-.6,0-1,.6-1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M19.5,20.5c-.6,0-1,.6-1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M19.5,20.5c-.6,0-1,.6-1,1.3,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.3,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M19.5,20.5c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M19.5,20.5c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M19.5,20.5c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M19.5,20.5c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2s-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M19.5,20.5c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M19.5,20.5c-.6,0-1,.6-1,1.2s.5,1.2,1.1,1.2c.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M19.5,20.5c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M19.5,20.5c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M19.5,20.5c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M19.5,20.5c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M19.5,20.5c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2s-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M19.5,20.5c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1.1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M19.5,20.5c-.6,0-1,.6-1,1.2s.5,1.2,1,1.2c.6,0,1-.6,1-1.2,0-.7-.5-1.2-1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M19.5,20.5c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M19.5,20.5c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M19.5,20.5c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M19.5,20.5c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M19.5,20.5c-.6,0-1,.6-1,1.2,0,.7.5,1.2,1,1.2.6,0,1-.6,1-1.2,0-.7-.5-1.2-1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M19.5,20.5c-.6,0-1,.5-1,1.2,0,.7.5,1.2,1,1.2.6,0,1-.5,1-1.2,0-.7-.5-1.2-1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M19.5,20.5c-.6,0-1,.5-1,1.2,0,.6.5,1.2,1,1.2.6,0,1-.5,1-1.2,0-.6-.5-1.2-1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M19.5,20.6c-.6,0-1,.5-1,1.2,0,.6.5,1.2,1,1.2s1-.5,1-1.2c0-.6-.5-1.2-1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M19.5,20.6c-.6,0-1,.5-1,1.2,0,.6.5,1.2,1,1.1.6,0,1-.5,1-1.2,0-.6-.5-1.2-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M19.5,20.6c-.6,0-1,.5-1,1.2,0,.6.5,1.2,1,1.1.6,0,1-.5,1-1.2,0-.6-.5-1.2-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M19.5,20.6c-.6,0-1,.5-1,1.2,0,.6.5,1.2,1,1.1.6,0,1-.5,1-1.2,0-.6-.5-1.2-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M19.5,20.6c-.6,0-1,.5-1,1.2,0,.6.5,1.2,1,1.1.6,0,1-.5,1-1.2,0-.6-.5-1.2-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M19.5,20.6c-.5,0-1,.5-1,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5,1-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M19.5,20.6c-.5,0-1,.5-1,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5,1-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M19.5,20.6c-.5,0-1,.5-1,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5,1-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M19.5,20.6c-.5,0-1,.5-1,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5,1-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M19.5,20.6c-.5,0-1,.5-1,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5,1-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M19.5,20.6c-.5,0-1,.5-1,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5,1-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M19.5,20.6c-.5,0-1,.5-1,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5,1-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M19.5,20.6c-.5,0-1,.5-1,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5,1-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M19.5,20.6c-.5,0-1,.5-1,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5,1-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M19.5,20.6c-.5,0-1,.5-.9,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5.9-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M19.5,20.6c-.5,0-1,.5-.9,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5.9-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-353",
    d: "M19.5,20.6c-.5,0-1,.5-.9,1.2,0,.6.5,1.1,1,1.1.5,0,1-.5.9-1.2,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-353",
    d: "M19.5,20.6c-.5,0-1,.5-.9,1.1,0,.6.5,1.1,1,1.1.5,0,1-.5.9-1.1,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M19.5,20.6c-.5,0-1,.5-.9,1.1,0,.6.5,1.1,1,1.1.5,0,1-.5.9-1.1s-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M19.5,20.6c-.5,0-1,.5-.9,1.1,0,.6.5,1.1,1,1.1.5,0,1-.5.9-1.1,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M19.5,20.6c-.5,0-.9.5-.9,1.1,0,.6.5,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M19.5,20.6c-.5,0-.9.5-.9,1.1,0,.6.5,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.5,20.6c-.5,0-.9.5-.9,1.1,0,.6.5,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.5,20.6c-.5,0-.9.5-.9,1.1,0,.6.5,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.5-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.5,20.6c-.5,0-.9.5-.9,1.1,0,.6.4,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.5,20.6c-.5,0-.9.5-.9,1.1,0,.6.4,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M19.5,20.6c-.5,0-.9.5-.9,1.1,0,.6.4,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M19.5,20.6c-.5,0-.9.5-.9,1.1,0,.6.4,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M19.5,20.6c-.5,0-.9.5-.9,1.1,0,.6.4,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M19.5,20.6c-.5,0-.9.5-.9,1.1,0,.6.4,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M19.5,20.6c-.5,0-.9.5-.9,1.1,0,.6.4,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M19.5,20.6c-.5,0-.9.5-.9,1.1,0,.6.4,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M19.5,20.6c-.5,0-.9.5-.9,1.1,0,.6.4,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M19.5,20.6c-.5,0-.9.5-.9,1.1,0,.6.4,1.1,1,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M19.5,20.6c-.5,0-.9.5-.9,1.1s.4,1.1,1,1.1c.5,0,.9-.5.9-1.1,0-.6-.4-1.1-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M19.5,20.6c-.5,0-.9.5-.9,1.1,0,.6.4,1.1.9,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-.9-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-346",
    d: "M19.5,20.6c-.5,0-.9.5-.9,1.1,0,.6.4,1.1.9,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-.9-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-346",
    d: "M19.5,20.7c-.5,0-.9.5-.9,1.1,0,.6.4,1.1.9,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-.9-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M19.5,20.7c-.5,0-.9.5-.9,1.1,0,.6.4,1.1.9,1.1.5,0,.9-.5.9-1.1,0-.6-.4-1.1-.9-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-330",
    d: "M19.5,20.7c-.5,0-.9.5-.9,1.1,0,.6.4,1.1.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1.1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M19.5,20.7c-.5,0-.9.5-.9,1.1,0,.6.4,1.1.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1.1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M19.5,20.7c-.5,0-.9.5-.9,1.1,0,.6.4,1.1.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1.1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M19.5,20.7c-.5,0-.9.5-.9,1.1,0,.6.4,1.1.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1.1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M19.5,20.7c-.5,0-.9.5-.9,1.1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M19.5,20.7c-.5,0-.9.5-.9,1.1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M19.5,20.7c-.5,0-.9.5-.9,1.1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M19.5,20.7c-.5,0-.9.5-.9,1.1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M19.5,20.7c-.5,0-.9.5-.9,1.1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M19.5,20.7c-.5,0-.9.5-.9,1.1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-345",
    d: "M19.5,20.7c-.5,0-.9.5-.9,1.1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M19.5,20.7c-.5,0-.9.5-.9,1.1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M19.5,20.7c-.5,0-.9.5-.9,1.1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M19.5,20.7c-.5,0-.9.5-.9,1.1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M19.5,20.7c-.5,0-.9.5-.9,1.1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1.1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M19.5,20.7c-.5,0-.9.5-.9,1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M19.5,20.7c-.5,0-.9.5-.9,1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M19.5,20.7c-.5,0-.9.5-.9,1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M19.5,20.7c-.5,0-.9.5-.9,1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M19.5,20.7c-.5,0-.9.5-.9,1,0,.6.4,1,.9,1,.5,0,.9-.5.9-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M19.5,20.7c-.5,0-.9.5-.8,1,0,.6.4,1,.9,1,.5,0,.9-.5.8-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M19.5,20.7c-.5,0-.9.5-.8,1,0,.6.4,1,.9,1,.5,0,.9-.5.8-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M19.5,20.7c-.5,0-.9.5-.8,1,0,.6.4,1,.9,1,.5,0,.9-.5.8-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M19.5,20.7c-.5,0-.9.5-.8,1,0,.6.4,1,.9,1,.5,0,.9-.5.8-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M19.5,20.7c-.5,0-.9.5-.8,1,0,.6.4,1,.9,1,.5,0,.9-.5.8-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M19.5,20.7c-.5,0-.9.5-.8,1,0,.6.4,1,.9,1,.5,0,.9-.5.8-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M19.5,20.7c-.5,0-.8.5-.8,1,0,.6.4,1,.9,1,.5,0,.8-.5.8-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M19.5,20.7c-.5,0-.8.5-.8,1,0,.6.4,1,.9,1,.5,0,.8-.5.8-1,0-.6-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.5,20.7c-.5,0-.8.5-.8,1,0,.5.4,1,.9,1,.5,0,.8-.5.8-1,0-.5-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M19.5,20.7c-.5,0-.8.5-.8,1,0,.5.4,1,.9,1,.5,0,.8-.5.8-1,0-.5-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "M19.5,20.7c-.5,0-.8.5-.8,1,0,.5.4,1,.9,1,.5,0,.8-.5.8-1,0-.5-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M19.5,20.7c-.5,0-.8.5-.8,1,0,.5.4,1,.9,1,.5,0,.8-.5.8-1,0-.5-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M19.5,20.7c-.5,0-.8.5-.8,1,0,.5.4,1,.9,1,.5,0,.8-.5.8-1,0-.5-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M19.5,20.7c-.5,0-.8.5-.8,1,0,.5.4,1,.9,1,.5,0,.8-.5.8-1,0-.5-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-331",
    d: "M19.5,20.7c-.5,0-.8.5-.8,1,0,.5.4,1,.9,1,.5,0,.8-.5.8-1,0-.5-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M19.5,20.7c-.5,0-.8.5-.8,1,0,.5.4,1,.9,1,.5,0,.8-.5.8-1,0-.5-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M19.5,20.8c-.5,0-.8.5-.8,1,0,.5.4,1,.9,1,.5,0,.8-.5.8-1,0-.5-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M19.5,20.8c-.5,0-.8.5-.8,1,0,.5.4,1,.9,1,.5,0,.8-.5.8-1,0-.5-.4-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "M19.5,20.8c-.5,0-.8.5-.8,1,0,.5.4,1,.9.9.5,0,.8-.5.8-1,0-.5-.4-1-.9-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-322",
    d: "M19.5,20.8c-.5,0-.8.4-.8,1,0,.5.4,1,.8.9.5,0,.8-.4.8-1,0-.5-.4-1-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M19.5,20.8c-.5,0-.8.4-.8,1,0,.5.4,1,.8.9.5,0,.8-.4.8-1,0-.5-.4-1-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-311",
    d: "M19.5,20.8c-.5,0-.8.4-.8,1,0,.5.4,1,.8.9.5,0,.8-.4.8-1s-.4-1-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M19.5,20.8c-.5,0-.8.4-.8,1,0,.5.4.9.8.9.5,0,.8-.4.8-1,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M19.5,20.8c-.5,0-.8.4-.8,1,0,.5.4.9.8.9.5,0,.8-.4.8-1,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-313",
    d: "M19.5,20.8c-.5,0-.8.4-.8,1,0,.5.4.9.8.9.5,0,.8-.4.8-1,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M19.5,20.8c-.4,0-.8.4-.8,1,0,.5.4.9.8.9.4,0,.8-.4.8-1,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M19.5,20.8c-.4,0-.8.4-.8,1,0,.5.4.9.8.9.4,0,.8-.4.8-1,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M19.5,20.8c-.4,0-.8.4-.8,1,0,.5.4.9.8.9.4,0,.8-.4.8-1,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M19.5,20.8c-.4,0-.8.4-.8,1,0,.5.4.9.8.9.4,0,.8-.4.8-1,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-337",
    d: "M19.5,20.8c-.4,0-.8.4-.8,1,0,.5.4.9.8.9.4,0,.8-.4.8-1,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M19.5,20.8c-.4,0-.8.4-.8,1,0,.5.4.9.8.9.4,0,.8-.4.8-1,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M19.5,20.8c-.4,0-.8.4-.8,1,0,.5.4.9.8.9.4,0,.8-.4.8-1,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M19.5,20.8c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "M19.5,20.8c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M19.5,20.8c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M19.5,20.8c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M19.5,20.8c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M19.5,20.8c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M19.5,20.8c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M19.5,20.8c-.4,0-.8.4-.8.9,0,.5.4.9.8.9s.8-.4.8-.9c0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M19.5,20.8c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M19.5,20.8c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M19.5,20.8c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M19.5,20.8c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M19.5,20.8c-.4,0-.8.4-.8.9,0,.5.4.9.8.9.4,0,.8-.4.8-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M19.5,20.8c-.4,0-.8.4-.7.9,0,.5.4.9.8.9.4,0,.8-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-329",
    d: "M19.5,20.8c-.4,0-.8.4-.7.9,0,.5.4.9.8.9.4,0,.8-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M19.5,20.8c-.4,0-.8.4-.7.9,0,.5.4.9.8.9.4,0,.8-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M19.5,20.8c-.4,0-.8.4-.7.9,0,.5.4.9.8.9.4,0,.8-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M19.5,20.8c-.4,0-.8.4-.7.9,0,.5.4.9.8.9.4,0,.8-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M19.5,20.8c-.4,0-.7.4-.7.9,0,.5.4.9.8.9.4,0,.7-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M19.5,20.8c-.4,0-.7.4-.7.9,0,.5.4.9.8.9.4,0,.7-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M19.5,20.8c-.4,0-.7.4-.7.9,0,.5.4.9.8.9.4,0,.7-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M19.5,20.8c-.4,0-.7.4-.7.9,0,.5.4.9.8.9.4,0,.7-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M19.5,20.9c-.4,0-.7.4-.7.9,0,.5.4.9.8.9.4,0,.7-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M19.5,20.9c-.4,0-.7.4-.7.9,0,.5.4.9.8.9.4,0,.7-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M19.5,20.9c-.4,0-.7.4-.7.9,0,.5.4.9.8.9.4,0,.7-.4.7-.9,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M19.5,20.9c-.4,0-.7.4-.7.9,0,.5.4.9.8.8.4,0,.7-.4.7-.9,0-.5-.4-.9-.8-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M19.5,20.9c-.4,0-.7.4-.7.9,0,.5.3.9.8.8.4,0,.7-.4.7-.9,0-.5-.3-.9-.8-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M19.5,20.9c-.4,0-.7.4-.7.9,0,.5.3.9.8.8.4,0,.7-.4.7-.9,0-.5-.3-.9-.8-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M19.5,20.9c-.4,0-.7.4-.7.9,0,.5.3.8.8.8.4,0,.7-.4.7-.9,0-.5-.3-.8-.8-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M19.5,20.9c-.4,0-.7.4-.7.9,0,.5.3.8.8.8s.7-.4.7-.9c0-.5-.3-.8-.8-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M19.5,20.9c-.4,0-.7.4-.7.9,0,.5.3.8.7.8.4,0,.7-.4.7-.9,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M19.5,20.9c-.4,0-.7.4-.7.9,0,.5.3.8.7.8.4,0,.7-.4.7-.9,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M19.5,20.9c-.4,0-.7.4-.7.9,0,.5.3.8.7.8.4,0,.7-.4.7-.9,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M19.5,20.9c-.4,0-.7.4-.7.9,0,.5.3.8.7.8.4,0,.7-.4.7-.9,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M19.5,20.9c-.4,0-.7.4-.7.9,0,.5.3.8.7.8.4,0,.7-.4.7-.9,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M19.5,20.9c-.4,0-.7.4-.7.9,0,.5.3.8.7.8.4,0,.7-.4.7-.9,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M19.5,20.9c-.4,0-.7.4-.7.9,0,.5.3.8.7.8.4,0,.7-.4.7-.9,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M19.5,20.9c-.4,0-.7.4-.7.8,0,.5.3.8.7.8.4,0,.7-.4.7-.8,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-327",
    d: "M19.5,20.9c-.4,0-.7.4-.7.8,0,.5.3.8.7.8.4,0,.7-.4.7-.8,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M19.5,20.9c-.4,0-.7.4-.7.8,0,.5.3.8.7.8.4,0,.7-.4.7-.8,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M19.5,20.9c-.4,0-.7.4-.7.8,0,.5.3.8.7.8.4,0,.7-.4.7-.8,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M19.5,20.9c-.4,0-.7.4-.7.8,0,.5.3.8.7.8.4,0,.7-.4.7-.8,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M19.5,20.9c-.4,0-.7.4-.7.8,0,.5.3.8.7.8.4,0,.7-.4.7-.8,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M19.5,20.9c-.4,0-.7.4-.7.8,0,.5.3.8.7.8.4,0,.7-.4.7-.8,0-.5-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M19.5,20.9c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M19.5,20.9c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M19.5,20.9c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M19.5,20.9c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M19.5,20.9c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M19.5,20.9c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M19.5,20.9c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M19.5,20.9c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-328",
    d: "M19.5,20.9c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M19.5,20.9c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M19.5,20.9c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M19.5,20.9c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M19.5,20.9c-.4,0-.7.4-.7.8,0,.4.3.8.7.8.4,0,.7-.4.7-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M19.5,21c-.4,0-.7.4-.6.8,0,.4.3.8.7.8.4,0,.7-.4.6-.8,0-.4-.3-.8-.7-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M19.5,21c-.4,0-.6.4-.6.8,0,.4.3.7.7.7.4,0,.6-.4.6-.8,0-.4-.3-.7-.7-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M19.5,21c-.4,0-.6.3-.6.8,0,.4.3.7.7.7.4,0,.6-.3.6-.8,0-.4-.3-.7-.7-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-355",
    d: "M19.5,21c-.3,0-.6.3-.6.7,0,.4.3.7.6.7.3,0,.6-.3.6-.7,0-.4-.3-.7-.6-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M19.5,21c-.3,0-.6.3-.6.7,0,.4.3.7.6.7.3,0,.6-.3.6-.7,0-.4-.3-.7-.6-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M19.5,21c-.3,0-.6.3-.6.7,0,.4.3.7.6.7.3,0,.6-.3.6-.7,0-.4-.3-.7-.6-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.5,21c-.3,0-.6.3-.6.7,0,.4.3.7.6.7s.6-.3.6-.7c0-.4-.3-.7-.6-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M19.5,21.1c-.3,0-.6.3-.6.7,0,.4.3.7.6.7.3,0,.6-.3.6-.7,0-.4-.3-.7-.6-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M19.5,21.1c-.3,0-.6.3-.5.7,0,.4.3.7.6.6.3,0,.6-.3.5-.7,0-.4-.3-.7-.6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M19.5,21.1c-.3,0-.5.3-.5.7,0,.4.3.6.6.6.3,0,.5-.3.5-.7,0-.4-.3-.6-.6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-318",
    d: "M19.5,21.1c-.3,0-.5.3-.5.6,0,.3.3.6.6.6.3,0,.5-.3.5-.6,0-.3-.3-.6-.6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M19.5,21.1c-.3,0-.5.3-.5.6,0,.3.2.6.5.6.3,0,.5-.3.5-.6,0-.3-.2-.6-.5-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M19.5,21.1c-.3,0-.5.3-.5.6,0,.3.2.6.5.6.3,0,.5-.3.5-.6,0-.3-.2-.6-.5-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M19.5,21.1c-.3,0-.5.3-.5.6,0,.3.2.6.5.6.3,0,.5-.3.5-.6,0-.3-.2-.6-.5-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-343",
    d: "M19.5,21.2c-.3,0-.5.3-.5.6,0,.3.2.6.5.6.3,0,.5-.3.5-.6,0-.3-.2-.6-.5-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M19.5,21.2c-.3,0-.5.3-.5.6,0,.3.2.6.5.5.3,0,.5-.3.5-.6,0-.3-.2-.6-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M19.5,21.2c-.3,0-.5.3-.5.6,0,.3.2.5.5.5.3,0,.5-.3.5-.6,0-.3-.2-.5-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M19.5,21.2c-.3,0-.4.2-.4.5,0,.3.2.5.5.5.3,0,.4-.2.4-.5,0-.3-.2-.5-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "M19.5,21.2c-.2,0-.4.2-.4.5,0,.3.2.5.5.5.2,0,.4-.2.4-.5,0-.3-.2-.5-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M19.5,21.2c-.2,0-.4.2-.4.5,0,.3.2.5.4.5.2,0,.4-.2.4-.5,0-.3-.2-.5-.4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-351",
    d: "M19.5,21.2c-.2,0-.4.2-.4.5,0,.3.2.5.4.5.2,0,.4-.2.4-.5,0-.3-.2-.5-.4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M19.5,21.2c-.2,0-.4.2-.4.5,0,.3.2.5.4.5.2,0,.4-.2.4-.5,0-.3-.2-.5-.4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-342",
    d: "M19.5,21.3c-.2,0-.4.2-.4.5,0,.3.2.5.4.5.2,0,.4-.2.4-.5,0-.3-.2-.5-.4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M19.5,21.3c-.2,0-.4.2-.4.5,0,.2.2.4.4.4.2,0,.4-.2.4-.5,0-.2-.2-.4-.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M19.5,21.3c-.2,0-.4.2-.4.4,0,.2.2.4.4.4.2,0,.4-.2.4-.4,0-.2-.2-.4-.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M19.5,21.3c-.2,0-.4.2-.4.4,0,.2.2.4.4.4.2,0,.4-.2.4-.4,0-.2-.2-.4-.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M19.5,21.3c-.2,0-.3.2-.3.4,0,.2.2.4.4.4.2,0,.3-.2.3-.4,0-.2-.2-.4-.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M19.5,21.3c-.2,0-.3.2-.3.4,0,.2.2.4.3.4.2,0,.3-.2.3-.4,0-.2-.2-.4-.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M19.5,21.3c-.2,0-.3.2-.3.4,0,.2.2.4.3.4.2,0,.3-.2.3-.4,0-.2-.2-.4-.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M19.5,21.4c-.2,0-.3.2-.3.4,0,.2.1.4.3.4.2,0,.3-.2.3-.4,0-.2-.1-.4-.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M19.5,21.4c-.2,0-.3.2-.3.4,0,.2.1.3.3.3.2,0,.3-.2.3-.4,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M19.5,21.4c-.2,0-.3.2-.3.3,0,.2.1.3.3.3.2,0,.3-.2.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M19.5,21.4c-.2,0-.3.1-.3.3,0,.2.1.3.3.3.2,0,.3-.1.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M19.5,21.4c-.1,0-.3.1-.3.3,0,.2.1.3.3.3.1,0,.3-.1.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M19.5,21.4c-.1,0-.2.1-.2.3,0,.2.1.3.3.3.1,0,.2-.1.2-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M19.5,21.4c-.1,0-.2.1-.2.3,0,.2.1.3.2.3s.2-.1.2-.3c0-.2-.1-.3-.2-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M19.5,21.5c-.1,0-.2.1-.2.3,0,.1.1.3.2.3.1,0,.2-.1.2-.3,0-.1-.1-.3-.2-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M19.5,21.5c-.1,0-.2.1-.2.3,0,.1.1.2.2.2.1,0,.2-.1.2-.3,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M19.5,21.5c-.1,0-.2.1-.2.2,0,.1,0,.2.2.2.1,0,.2-.1.2-.2,0-.1,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M19.5,21.5c-.1,0-.2.1-.2.2,0,.1,0,.2.2.2.1,0,.2-.1.2-.2,0-.1,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M19.5,21.5c0,0-.2,0-.2.2,0,.1,0,.2.2.2,0,0,.2,0,.2-.2,0-.1,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M19.5,21.5c0,0-.2,0-.2.2,0,.1,0,.2.2.2,0,0,.2,0,.2-.2,0-.1,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M19.5,21.5c0,0-.2,0-.2.2,0,.1,0,.2.2.2,0,0,.2,0,.2-.2,0-.1,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M19.5,21.6c0,0-.1,0-.1.2,0,0,0,.2.1.2,0,0,.1,0,.1-.2s0-.2-.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M19.5,21.6c0,0-.1,0-.1.2,0,0,0,.2.1.2,0,0,.1,0,.1-.2,0,0,0-.2-.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M19.5,21.6c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M19.5,21.6c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M19.5,21.6c0,0,0,0,0,.1,0,0,0,.1,0,.1,0,0,0,0,0-.1,0,0,0-.1,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M19.5,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M19.5,21.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M19.5,21.7s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M19.5,21.7s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M19.5,21.7s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M19.5,21.7s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M19.5,21.7s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,20.6c-.4,0-.8.4-.8,1,0,.5.4.9.8.9.4,0,.8-.4.8-1,0-.5-.4-.9-.8-.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-211"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.6,
    y: 21.9,
    width: 0.7,
    height: 0.8,
    transform: "translate(-5.7 37.6) rotate(-79.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9,22c-.2,0-.4.2-.4.3,0,.2.2.3.4.3.2,0,.4-.2.4-.3,0-.2-.2-.3-.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9,22c-.2,0-.4.2-.4.3,0,.2.2.3.4.3.2,0,.4-.2.4-.3,0-.2-.2-.3-.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M19.9,22c-.2,0-.4.2-.3.3,0,.2.2.3.4.3.2,0,.4-.2.3-.3,0-.2-.2-.3-.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M19.9,22c-.2,0-.3.2-.3.3,0,.2.2.3.4.3.2,0,.3-.2.3-.3,0-.2-.2-.3-.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M19.9,22c-.2,0-.3.2-.3.3,0,.2.2.3.4.3.2,0,.3-.2.3-.3,0-.2-.2-.3-.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.2.2.3.4.3.2,0,.3-.1.3-.3,0-.2-.2-.3-.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.2.2.3.4.3s.3-.1.3-.3c0-.2-.2-.3-.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.2.2.3.3.3.2,0,.3-.1.3-.3,0-.2-.2-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.2.2.3.3.3.2,0,.3-.1.3-.3,0-.2-.2-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.2.2.3.3.3.2,0,.3-.1.3-.3,0-.2-.2-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.2.2.3.3.3.2,0,.3-.1.3-.3,0-.2-.2-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-315",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.2.2.3.3.3.2,0,.3-.1.3-.3,0-.2-.2-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.2.2.3.3.3.2,0,.3-.1.3-.3,0-.2-.2-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.2.2.3.3.3.2,0,.3-.1.3-.3,0-.2-.2-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.2.2.3.3.3.2,0,.3-.1.3-.3,0-.2-.2-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.2.1.3.3.3.2,0,.3-.1.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.2.1.3.3.3s.3-.1.3-.3c0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.2.1.3.3.3.2,0,.3-.1.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.2.1.3.3.3.2,0,.3-.1.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.2.1.3.3.3.2,0,.3-.1.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.2.1.3.3.3.2,0,.3-.1.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.2.1.3.3.3.2,0,.3-.1.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.2.1.3.3.3.2,0,.3-.1.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.2.1.3.3.3.2,0,.3-.1.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.2.1.3.3.3.2,0,.3-.1.3-.3,0-.2-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.1.1.3.3.3.2,0,.3-.1.3-.3,0-.1-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.1.1.3.3.3.2,0,.3-.1.3-.3,0-.1-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.1.1.3.3.3.2,0,.3-.1.3-.3,0-.1-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.1.1.3.3.3.2,0,.3-.1.3-.3,0-.1-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-349",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.1.1.3.3.3.2,0,.3-.1.3-.3,0-.1-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.1.1.3.3.3.2,0,.3-.1.3-.3,0-.1-.1-.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.1.1.3.3.2.2,0,.3-.1.3-.3,0-.1-.1-.3-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.1.1.2.3.2.2,0,.3-.1.3-.3,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-319",
    d: "M19.9,22c-.2,0-.3.1-.3.3,0,.1.1.2.3.2.2,0,.3-.1.3-.3,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M19.9,22c-.1,0-.3.1-.3.3,0,.1.1.2.3.2.1,0,.3-.1.3-.3,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M19.9,22.1c-.1,0-.3.1-.3.3,0,.1.1.2.3.2.1,0,.3-.1.3-.3,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M19.9,22.1c-.1,0-.3.1-.3.2,0,.1.1.2.3.2.1,0,.3-.1.3-.2,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M19.9,22.1c-.1,0-.3.1-.3.2,0,.1.1.2.3.2.1,0,.3-.1.3-.2,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M19.9,22.1c-.1,0-.3.1-.3.2,0,.1.1.2.3.2.1,0,.3-.1.3-.2,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M19.9,22.1c-.1,0-.3.1-.3.2,0,.1.1.2.3.2.1,0,.3-.1.3-.2,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M19.9,22.1c-.1,0-.3.1-.3.2,0,.1.1.2.3.2.1,0,.3-.1.2-.2,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M19.9,22.1c-.1,0-.2.1-.2.2,0,.1.1.2.3.2.1,0,.2-.1.2-.2,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-350",
    d: "M19.9,22.1c-.1,0-.2.1-.2.2,0,.1.1.2.3.2.1,0,.2-.1.2-.2,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M19.9,22.1c-.1,0-.2.1-.2.2,0,.1.1.2.3.2.1,0,.2-.1.2-.2,0-.1-.1-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M19.9,22.1c-.1,0-.2.1-.2.2,0,.1.1.2.2.2.1,0,.2-.1.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M19.9,22.1c-.1,0-.2.1-.2.2,0,.1.1.2.2.2.1,0,.2-.1.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M19.9,22.1c-.1,0-.2.1-.2.2,0,.1.1.2.2.2.1,0,.2-.1.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M19.9,22.1c-.1,0-.2.1-.2.2,0,.1.1.2.2.2.1,0,.2-.1.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M19.9,22.1c-.1,0-.2.1-.2.2,0,.1.1.2.2.2.1,0,.2-.1.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M19.9,22.1c-.1,0-.2,0-.2.2s.1.2.2.2c.1,0,.2,0,.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M19.9,22.1c-.1,0-.2,0-.2.2,0,.1.1.2.2.2.1,0,.2,0,.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M19.9,22.1c-.1,0-.2,0-.2.2,0,.1.1.2.2.2.1,0,.2,0,.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M19.9,22.1c-.1,0-.2,0-.2.2,0,.1.1.2.2.2.1,0,.2,0,.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M19.9,22.1c-.1,0-.2,0-.2.2,0,.1.1.2.2.2.1,0,.2,0,.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M19.9,22.1c-.1,0-.2,0-.2.2,0,.1.1.2.2.2.1,0,.2,0,.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M19.9,22.1c-.1,0-.2,0-.2.2,0,.1.1.2.2.2.1,0,.2,0,.2-.2,0-.1-.1-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M19.9,22.1c-.1,0-.2,0-.2.2,0,.1,0,.2.2.2.1,0,.2,0,.2-.2,0-.1,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-312",
    d: "M19.9,22.1c-.1,0-.2,0-.2.2,0,.1,0,.2.2.2.1,0,.2,0,.2-.2,0-.1,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M19.9,22.1c-.1,0-.2,0-.2.2,0,.1,0,.2.2.2.1,0,.2,0,.2-.2,0-.1,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "M19.9,22.1c-.1,0-.2,0-.2.2,0,.1,0,.2.2.2.1,0,.2,0,.2-.2,0-.1,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M19.9,22.1c-.1,0-.2,0-.2.2,0,.1,0,.2.2.2.1,0,.2,0,.2-.2,0-.1,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M19.9,22.1c-.1,0-.2,0-.2.2,0,.1,0,.2.2.2.1,0,.2,0,.2-.2,0-.1,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M19.9,22.1c-.1,0-.2,0-.2.2,0,0,0,.2.2.2.1,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M19.9,22.1c-.1,0-.2,0-.2.2,0,0,0,.2.2.2.1,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-354",
    d: "M19.9,22.1c-.1,0-.2,0-.2.2,0,0,0,.2.2.2.1,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M19.9,22.1c-.1,0-.2,0-.2.2,0,0,0,.2.2.2.1,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M19.9,22.1c-.1,0-.2,0-.2.2,0,0,0,.2.2.2.1,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M19.9,22.1c-.1,0-.2,0-.2.2,0,0,0,.2.2.2.1,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M19.9,22.1c-.1,0-.2,0-.2.2,0,0,0,.2.2.2.1,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M19.9,22.1c0,0-.2,0-.2.2,0,0,0,.2.2.2,0,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M19.9,22.1c0,0-.2,0-.2.2,0,0,0,.2.2.2,0,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M19.9,22.1c0,0-.2,0-.2.2,0,0,0,.2.2.2,0,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-352",
    d: "M19.9,22.1c0,0-.2,0-.2.2,0,0,0,.2.2.2,0,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M19.9,22.1c0,0-.2,0-.2.2,0,0,0,.2.2.2,0,0,.2,0,.2-.2,0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M19.9,22.1c0,0-.2,0-.2.2,0,0,0,.1.2.1,0,0,.2,0,.2-.2,0,0,0-.1-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M19.9,22.1c0,0-.2,0-.2.2,0,0,0,.1.2.1,0,0,.2,0,.2-.2,0,0,0-.1-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M19.9,22.1c0,0-.2,0-.2.1,0,0,0,.1.2.1,0,0,.2,0,.2-.2,0,0,0-.1-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M19.9,22.2c0,0-.2,0-.2.1,0,0,0,.1.2.1,0,0,.2,0,.2-.1,0,0,0-.1-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M19.9,22.2c0,0-.2,0-.2.1,0,0,0,.1.2.1,0,0,.2,0,.2-.1,0,0,0-.1-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M19.9,22.2c0,0-.2,0-.1.1,0,0,0,.1.2.1,0,0,.2,0,.1-.1,0,0,0-.1-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M19.9,22.2c0,0-.1,0-.1.1,0,0,0,.1.2.1,0,0,.1,0,.1-.1,0,0,0-.1-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M19.9,22.2c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M19.9,22.2c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M19.9,22.2c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-333",
    d: "M19.9,22.2c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M19.9,22.2c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M19.9,22.2c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M19.9,22.2c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-356",
    d: "M19.9,22.2c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M19.9,22.2c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M19.9,22.2c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M19.9,22.2c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M19.9,22.2c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M19.9,22.2c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M19.9,22.2c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M19.9,22.2c0,0-.1,0-.1.1,0,0,0,0,.1,0,0,0,.1,0,.1-.1,0,0,0,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M19.9,22.2c0,0-.1,0-.1.1,0,0,0,0,.1,0,0,0,.1,0,.1-.1,0,0,0,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M19.9,22.2c0,0-.1,0-.1,0,0,0,0,0,.1,0,0,0,.1,0,.1,0,0,0,0,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M19.9,22.2c0,0-.1,0-.1,0,0,0,0,0,.1,0,0,0,.1,0,.1,0,0,0,0,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M19.9,22.2c0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,0,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-323",
    d: "M19.9,22.2c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M19.9,22.2c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M19.9,22.2c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M19.9,22.2s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M19.9,22.2s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M19.9,22.2s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M19.9,22.2s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M19.9,22.2s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M19.9,22.2s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M19.9,22.2s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M19.9,22.2s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M19.9,22.2s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M19.9,22.2s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M19.9,22.2s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M19.9,22.2s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M19.9,22.2s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M19.9,22.2s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M19.9,22.2s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M19.9,22.3s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M19.9,22.3s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-339",
    d: "M19.9,22.3s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M19.9,22.3s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M19.9,22.3s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M19.9,22.3s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M19.9,22.3s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M19.9,22.3s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M19.9,22.3s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M19.9,22.3s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M19.9,22.3s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M19.9,22.3s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M19.9,22.3s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M19.9,22.3s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-340",
    d: "M19.9,22.3s0,0,0,0,0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M19.9,22.3s0,0,0,0,0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M19.9,22.3s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "19.9 22.3 19.9 22.3 19.9 22.3 19.9 22.3 19.9 22.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "19.9 22.3 19.9 22.3 19.9 22.3 19.9 22.3 19.9 22.3"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M19.1,18.7c-.5,0-.8.4-.8.9,0,.5.4.8.9.8.5,0,.8-.4.8-.9,0-.5-.4-.8-.9-.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M19.5,20.9c0,0-.1,0-.1.1,0,0,0,.1.1.1,0,0,.1,0,.1-.1,0,0,0-.1-.1-.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M21.3,23.6c0,.4-.8.7-1.8.7s-1.8-.3-1.8-.7.8-.7,1.8-.7,1.8.3,1.8.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.1,16.8s1.2-2.3,3.8-.8c-.2-1.7-3-2.3-3.8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8,16.6s-1.2-2.3-3.8-.8c.2-1.7,3-2.3,3.8.8Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButtonBoy);
export default __webpack_public_path__ + "static/media/playButtonBoy.0010d9c0f209df5979c82f60bc80fa2b.svg";
export { ForwardRef as ReactComponent };